import air from './rate-management-air'
import express from './rate-management-express'
import lcl from './rate-management-lcl'

export default {
  // 运价维护
  rateManagement: {
    // 模块标题和描述
    title: '运价维护',
    description: '管理各类运价信息',
    priceDisplay: {
      mode: '价格显示模式',
      numeric: '单一币种(加价)',
      currencyStr: '多币种详情'
    },
    common: {
      selectAllMatched: '全选 ({count})',
      deselectAllMatched: '取消全选 ({count})',
      noDataToSelect: '当前查询没有可全选的数据',
      selectAllMustUnpublished: '存在不符合上架条件的数据，只有草稿和待导入状态才能批量上架',
      selectAllMustPublished: '存在不符合下架条件的数据，只有已发布状态才能批量下架',
      selectAllMustDraft: '存在不符合删除条件的数据，只有草稿状态才能批量删除',
      onlineConfirmTitle: '确认上架',
      onlineConfirmContent: '确定要将选中的 {count} 条运价上架吗？'
    },
    // 批量修改（air / lcl / preport / lastmile 共享抽屉通用文案）
    batchModify: {
      title: '批量修改',
      selectedCount: '已选择 {count} 条运价',
      filterScope: '当前筛选结果',
      reminder: '仅未发布（状态非“已发布”）的运价允许修改；已发布的运价将被自动跳过。未填写的字段保持不变；文本字段选择“清空”后会清除原值。',
      confirm: '确定',
      cancel: '取消',
      selectPlaceholder: '请选择',
      inputPlaceholder: '请输入',
      modify: '修改为',
      clearOption: '清空',
      noChange: '请至少填写一个需要修改的字段',
      invalidDate: '开始日期不能晚于结束日期',
      success: '批量修改成功：{count} 条',
      partialSuccess: '批量修改完成：成功 {success} 条，跳过 {skipped} 条，失败 {failed} 条',
      failed: '批量修改失败：{failed} 条',
      noData: '没有找到符合条件（未发布）的运价记录',
      networkError: '批量修改请求失败，请稍后重试',
      fields: {
        validDate: '有效期',
        priceTrend: '价格趋势',
        specialPriceStatus: '特价状态',
        vessel: '船名',
        voyage: '航次',
        voyageDays: '航程（天）',
        remarks: '备注',
        receivingInstructions: '接货特殊说明'
      },
      options: {
        priceTrend: {
          1: '上涨',
          2: '下跌',
          3: '平稳'
        },
        specialPriceStatus: {
          1: '不允许申请特价',
          2: '允许申请特价',
          3: '特价'
        }
      }
    },
    rail: {
      addTitle: '新建铁路运价',
      viewTitle: '铁路运价详情',
      editTitle: '编辑铁路运价',
      actions: {
        add: '新建运价',
        import: '导入',
        export: '导出',
        batchOperations: '批量操作',
        batchPublish: '批量发布',
        batchDisable: '批量禁用',
        batchEnable: '批量启用',
        downloadTemplate: '下载模板',
        view: '详情',
        edit: '编辑',
        more: '更多',
        copy: '复制',
        publish: '发布',
        disable: '禁用',
        enable: '启用'
      },
      columns: {
        index: '序号',
        priceNo: '运价编码',
        companyIds: '所属公司',
        supplier: '供应商',
        railCompany: '铁路公司',
        pol: '起运站',
        pod: '目的站',
        routeType: '线路',
        containerOwner: '箱属',
        cargoType: '货物类型',
        transportMode: '运输方式',
        transportTerms: '运输条款',
        directTransit: '直达/中转',
        countryOfDeparture: '起运国',
        countryOfDestination: '目的国',
        exitPort: '出境口岸',
        hsCode: 'HS编码',
        weightLimit: '限重(t)',
        freeDemurrage: '免堆(d)',
        validityDate: '有效期',
        status: '状态',
        action: '操作'
      },
      messages: {
        loadFailed: '获取铁路运价失败',
        exportSubmitFailed: '导出任务提交失败',
        exportSubmitted: '导出任务已提交',
        exportFailed: '导出失败',
        confirmExportTitle: '确认导出',
        confirmExportSelected: '将导出已勾选的 {count} 条铁路运价，导出任务将在后台执行，完成后可在任务中心下载。',
        confirmExportAll: '将按当前查询条件导出铁路运价，导出任务将在后台执行，完成后可在任务中心下载。',
        goTaskCenterTitle: '跳转任务中心',
        goTaskCenterContent: '是否前往任务中心查看导出进度？',
        goTaskCenterOk: '前往任务中心',
        confirm: '确认',
        cancel: '取消',
        publishSuccess: '发布成功',
        disableSuccess: '禁用成功',
        enableSuccess: '启用成功',
        copySuccess: '已复制运价信息，请确认后保存',
        templateDownloading: '正在下载模板',
        templateDownloaded: '模板已下载',
        templateDownloadFailed: '模板下载失败',
        publishFailed: '发布失败',
        disableFailed: '禁用失败',
        enableFailed: '启用失败',
        batchPublishFailed: '批量发布失败',
        batchDisableFailed: '批量禁用失败',
        batchEnableFailed: '批量启用失败'
      },
      validation: {
        selectRailRate: '请选择铁路运价',
        publishDraftOnly: '仅草稿状态的铁路运价可以发布',
        disablePublishedOnly: '仅发布成功的铁路运价可以禁用',
        enableDisabledOnly: '仅禁用的铁路运价可以启用',
        versionMissing: '数据版本号缺失，请刷新后重试'
      },
      import: {
        title: '导入铁路运价',
        template: '模板',
        downloadTemplate: '下载铁路运价模板',
        instructionTitle: '导入说明',
        instruction1: '1. 支持单个 Excel 文件导入，上传后会创建任务并在任务管理中处理。',
        instruction2: '2. 模板内基础数据字段可以填写对应 ID，也可以填写可搜索到的名称或编码。',
        instruction3: '3. 导入结果和失败行原因请到任务管理查看。',
        uploadText: '点击或拖拽文件到这里',
        uploadHint: '支持 .xlsx / .xls',
        reselect: '重新选择',
        cancel: '取消',
        startImport: '开始导入',
        downloadFailed: '模板下载失败',
        taskCreated: '导入任务已创建，请在任务管理查看处理结果',
        taskCreateFailed: '导入任务创建失败'
      },
      detail: {
        back: '返回',
        title: '铁路运价',
        surchargeTitle: '附加费',
        boxTypeSetting: '箱型设置',
        add: '新增',
        feeName: '费用名称',
        selectFee: '请选择费用',
        unit: '单位',
        currency: '币种',
        paymentType: '付款方式',
        paymentTypePlaceholder: '方式',
        prepaid: '预付',
        collect: '到付',
        minCharge: '最低收费',
        maxCharge: '最高收费',
        feeSource: '费用来源',
        systemRule: '系统规则',
        manualCreate: '手动创建',
        unitPrice: '单价',
        remarks: '备注',
        optional: '选填',
        action: '操作',
        boxTypeUpdated: '箱型设置已更新',
        surchargeMatchFailed: '附加费自动匹配失败',
        validPeriodRequired: '请选择有效期',
        versionMissing: '数据版本号缺失，请刷新后重试',
        surchargeContainerPriceRequired: '附加费第 {index} 行：请至少填写一个箱型的价格',
        surchargeUnitPriceRequired: '附加费第 {index} 行：请填写单价'
      },
      statusText: {
        draft: '待上架',
        published: '发布成功',
        expired: '失效',
        publishFailed: '发布失败',
        disabled: '禁用',
        pendingImport: '待导入'
      },
      display: {
        railwayBox: '铁路箱',
        inlandPortBox: '陆港箱',
        crBox: '中铁箱',
        nonCrBox: '非中铁箱',
        middleLine: '中线',
        northLine: '北线',
        southLine: '南线',
        southeastAsia: '东南亚',
        centralAsia: '中亚'
      },
      options: {
        direction: {
          outbound: '去程',
          inbound: '回程'
        },
        routeType: {
          middle: '中线',
          north: '北线',
          south: '南线',
          southeast: '东南亚',
          centralAsia: '中亚'
        },
        containerOwner: {
          coc: 'COC（班列箱）',
          soc: 'SOC（自有箱）',
          railwayBox: '铁路箱',
          inlandPortBox: '陆港箱',
          crBox: '中铁箱',
          nonCrBox: '非中铁箱'
        },
        directTransit: {
          direct: '直达',
          transit: '中转'
        },
        transportMode: {
          container: '集装箱',
          truck: '整车',
          lcl: '散货'
        },
        paymentMethod: {
          prepaid: '预付',
          collect: '到付'
        }
      },
      form: {
        basicInfo: '基本信息',
        priceNo: '运价编码',
        autoGenerate: '系统自动生成',
        company: '所属公司',
        supplier: '供应商',
        railCompany: '铁路公司',
        direction: '方向',
        pickupCity: '提箱地',
        routeType: '线路分类',
        containerOwner: '箱属',
        cargoType: '货物类型',
        cityOfDeparture: '起运城市',
        cityOfDestination: '目的城市',
        countryOfDeparture: '起运国',
        countryOfDestination: '目的国',
        pol: '起运站',
        pod: '目的站',
        exitPort: '出境口岸',
        entryPort: '入境境外对应口岸',
        hsCode: 'HS编码',
        weightLimit: '限重（吨）',
        freeDemurrage: '免堆存天数',
        transportTerms: '运输条款',
        directTransit: '直达/中转',
        validPeriod: '有效期',
        transitStations: '中转站点',
        remarks: '备注',
        status: '运价状态',
        specialPriceStatus: '特价状态',
        specialPriceStatusPlaceholder: '请选择特价状态',
        specialPriceStatusDisallow: '不允许申请特价',
        specialPriceStatusAllow: '允许申请特价',
        specialPriceStatusSpecial: '特价',
        weekdays: '班期/星期几',
        onePrice: '是否一口价',
        receivingInstructions: '接货特殊说明',
        trainDepartureTime: '发车时间',
        borderCrossTime: '出境时间',
        trainArrivalTime: '到站时间',
        weekdaysPlaceholder: '请选择班期/星期几',
        onePricePlaceholder: '请选择',
        receivingInstructionsPlaceholder: '请输入接货特殊说明',
        trainDepartureTimePlaceholder: '请选择发车时间',
        borderCrossTimePlaceholder: '请选择出境时间',
        trainArrivalTimePlaceholder: '请选择到站时间',
        transportMode: '运输方式',
        truckFreight: '整车运费',
        railFreight: '铁路运费',
        lclFreight: '散货运价',
        volumePricing: '上货量',
        setRange: '设置范围',
        addRow: '新增一行',
        add: '新增',
        truckType: '车种',
        stdWeight: '标重',
        unit: '单位',
        basePrice1: '基价1',
        basePrice2: '基价2',
        unitPrice: '单价',
        currency: '币种',
        paymentMethod: '付款方式',
        minPrice: '最低价',
        maxPrice: '最高价',
        action: '操作',
        containerType: '箱型',
        volumeRangeSetting: '上货量范围设置',
        volumeRangeTip: '设置上货量阶梯范围，每个阶梯对应价格矩阵中的一列，支持增删阶梯。',
        tier: '阶梯',
        tierDisplay: '第{index}段',
        startInclude: '起始（含）',
        endExclude: '结束（不含）',
        display: '显示',
        addTier: '添加阶梯',
        select: '请选择',
        input: '请输入',
        optional: '选填',
        startDate: '开始日期',
        endDate: '结束日期',
        noLimit: '不填则不限',
        transitStationsPlaceholder: '多个用逗号或分号分隔，如：郑州、武汉、西安',
        transitStationsTip: '必填，支持输入多个站点，用逗号或分号分隔',
        hsCodePlaceholder: '多个编码用逗号分隔',
        weightPlaceholder: '如 20',
        dayPlaceholder: '天',
        truckTypePlaceholder: '如 敞车',
        stdWeightPlaceholder: '如 60t',
        emptyTruckRows: '暂无数据，点击新增一行添加',
        emptyLclRows: '暂无散货运价，点击下方“新增”添加',
        emptyMatrixRows: '暂无价格记录，点击“新增一行”添加',
        volumeStartRequired: '上货量起始值必须大于等于0',
        volumeEndGreaterThanStart: '上货量结束值必须大于起始值',
        volumeRangeOverlap: '上货量范围不能重叠',
        volumeNoLimitLast: '上货量不限结束的范围必须放在最后',
        volumeApplied: '上货量范围已应用，保存后生效',
        previousVolumeEndRequired: '请先设置上一段的结束值',
        keepOneVolumeRange: '至少保留一个范围',
        companyRequired: '请选择所属公司',
        railCompanyRequired: '请选择铁路公司',
        directionRequired: '请选择方向',
        routeTypeRequired: '请选择线路分类',
        containerOwnerRequired: '请选择箱属',
        cargoTypeRequired: '请选择货物类型',
        transportModeRequired: '请选择运输方式',
        transportTermsRequired: '请选择运输条款',
        directTransitRequired: '请选择直达/中转',
        exitPortRequired: '请选择出境口岸',
        pickupCityRequired: '去程时提箱地不能为空',
        dangerousHsCodeRequired: '货物类型为危险品时，HS编码不能为空',
        hsCodeTooLong: 'HS编码不能超过50个字符',
        remarksTooLong: '备注不能超过500个字符',
        transitStationsRequired: '中转站点不能为空',
        validPeriodRequired: '请选择有效期',
        pickupCityWarning: '去程时请填写提箱地',
        transitStationsWarning: '中转时请填写中转站点',
        departureRequired: '请填写起运国、起运城市或起运站（至少一项）',
        destinationRequired: '请填写目的国、目的城市或目的站（至少一项）',
        truckRowsRequired: '请至少维护一条整车运价',
        truckTypeRequired: '整车运价第{index}行：请填写车种',
        stdWeightRequired: '整车运价第{index}行：请填写标重',
        truckUnitRequired: '整车运价第{index}行：请选择单位',
        truckCurrencyRequired: '整车运价第{index}行：请选择币种',
        truckVolumePriceRequired: '整车运价第{index}行：请至少填写一个上货量价格',
        truckBasePriceRequired: '整车运价第{index}行：请填写基价1和基价2',
        truckUnitPriceRequired: '整车运价第{index}行：请填写单价',
        lclRowsRequired: '请至少维护一条散货运价',
        lclUnitRequired: '散货运价第{index}行：请选择单位',
        lclCurrencyRequired: '散货运价第{index}行：请选择币种',
        lclUnitPriceRequired: '散货运价第{index}行：请填写单价',
        matrixRowsRequired: '请至少维护一条铁路运价价格',
        matrixContainerRequired: '价格矩阵第{index}行：请选择箱型',
        matrixContainerDuplicate: '价格矩阵中箱型不能重复：{container}',
        matrixCurrencyRequired: '价格矩阵第{index}行：请选择币种',
        matrixVolumePriceRequired: '价格矩阵第{index}行：请至少填写一个上货量价格',
        matrixUnitPriceRequired: '价格矩阵第{index}行：请填写单价',
        matrixRemarksTooLong: '价格矩阵第{index}行：备注不能超过100个字符'
      }
    },
    status: {
      draft: '待上架',
      normal: '正常',
      published: '已发布',
      expired: '已失效',
      offline: '已下架'
    },

    // 标签页导航
    tabs: {
      ecommerce: '电商运价',
      fcl: '整箱运价',
      lcl: '拼箱运价',
      air: '空运运价',
      express: '快递',
      preport: '港前运价',
      lastmile: '尾程运价',
      rail: '铁路运价'
    },

    actions: {
      importTitle: '导入运价 ({type})',
      clickToUpload: '点击或拖拽文件到此区域上传',
      uploadLimit: '支持格式：Excel (.xlsx, .xls)，单个文件不超过 10MB',
      downloadTemplate: '下载导入模板',
      startImport: '开始导入',
      downloadErrorReport: '下载错误报告',
      close: '关闭',
      viewDrafts: '查看草稿',
      batchPublishCount: '批量发布 ({count}条)'
    },

    messages: {
      importInstructions: '导入说明：',
      importStep1: '系统将解析您上传的 Excel 表格并自动进行校验与规则匹配；',
      importStep2: '校验通过的有效数据行将自动保存至草稿列表；',
      importStep3: '若存在冲突或异常行，系统会提供详细的错误日志报告供您比对调整。',
      uploading: '正在上传并读取文件...',
      validating: '正在校验数据有效性与主数据关联...',
      matching: '正在进行智能规则与计费项匹配...',
      saving: '正在批量入库保存至草稿...',
      processingWait: '数据正在后台高速解析处理中，请稍候...',
      importSuccess: '导入成功行数',
      conflictDetected: '发现冲突/重复行',
      validationFailed: '校验失败行数',
      autoMatchResult: '智能规则自动匹配结果：',
      rowsFailed: '行解析失败，可下载报告查看详细错误原因。',
      downloadingTemplate: '正在为您下载导入模板',
      generatingErrorReport: '正在生成并下载异常明细报告...',
      batchPublishSuccess: '已成功将 {count} 条导入草稿批量发布上架！',
      noValidTaskId: '未返回有效的任务 ID',
      importTaskSubmitted: '运价导入任务已提交，正在后台异步解析',
      uploadFailed: '上传处理失败',
      noErrorDetails: '没有可导出的错误明细',
      errorReportExported: '错误报告导出成功',
      confirmPublishFailed: '确认发布失败',
      errorReportTitle: '运价导入错误明细报告',
      errorReportLine: '行号: {rows}, 字段: {field}, 原因: {reason}'
    },

    fields: {
      markupMatched: '加价规则匹配成功 {count} 项',
      surchargeMatched: '附加费规则匹配成功 {count} 项'
    },

    lcl,

    air,

    express,

    // 电商运价模块 (Ecommerce)
    ecommerce: {
      placeholders: {
        priceNo: '请输入运价编号',
        airline: '请选择航空公司',
        pol: '请选择起飞地',
        pod: '请选择目的港',
        remark: '如预约要求、截货时间等'
      },
      columns: {
        priceNo: '运价编号',
        airline: '航空公司',
        pol: '起飞地',
        pod: '卸货港',
        normal: 'N价',
        p100: '100+',
        validity: '有效期',
        status: '状态',
        actions: '操作',
        feeName: '费用名称',
        price: '单价',
        unit: '单位',
        remark: '备注'
      },
      fields: {
        priceNo: '运价编号',
        rateType: '运价类型',
        airline: '航空公司',
        office: '分公司',
        cargoType: '货物类型',
        directFlag: '直达/中转',
        pol: '起飞地',
        pod: '目的港',
        validityDate: '有效期',
        transitTime: '时效(天)',
        remark: '备注'
      },
      enums: {
        status: {
          draft: '待上架',
          normal: '正常',
          expired: '失效',
          offline: '下架',
          disabled: '禁用'
        },
        rateTypes: {
          level1: '一级代理',
          level2: '二级代理',
          ecommerce: '电商价格'
        },
        offices: {
          sh: '上海',
          sz: '深圳',
          gz: '广州'
        }
      },
      sections: {
        basicInfo: '基本信息',
        routeInfo: '航线信息',
        densityRate: '等级运价',
        surcharge: '附加费',
        remark: '备注'
      },
      actions: {
        back: '返回',
        edit: '编辑',
        copy: '复制',
        saveDraft: '保存草稿',
        publish: '发布',
        add: '新建',
        import: '导入',
        export: '导出',
        downloadTemplate: '下载模板',
        batchOperations: '批量操作',
        batchPublish: '批量发布',
        batchDelete: '批量删除',
        view: '详情',
        more: '更多',
        delete: '删除',
        addSurcharge: '添加附加费'
      },
      messages: {
        fetchFailed: '获取数据失败',
        saveSuccess: '草稿保存成功',
        publishSuccess: '运价发布成功',
        deleteSuccess: '删除成功',
        downloadingTemplate: '正在下载',
        uploading: '正在上传...',
        validating: '正在校验...',
        matching: '匹配规则...',
        saving: '保存数据...',
        generatingErrorReport: '正在生成错误报告...',
        batchPublishSuccess: '已批量发布 {count} 条'
      }
    },

    // 整箱运价管理 (FCL)
    fcl: {
      // 页面标题
      title: '整箱运价管理',
      description: '管理整箱运价信息',
      createTitle: '新增整箱运价',
      editTitle: '编辑整箱运价',
      viewTitle: '查看整箱运价详情',

      // 筛选条件
      filters: {
        // 基础信息筛选
        priceNo: '运价号',
        batchNo: '批次号',
        pricingNature: '约价性质',
        batchNoPlaceholder: '请输入批次号',
        freightType: '运价类型',
        pol: '起运港',
        pod: '卸货港',
        podRouteCategory: '卸货港航线分类',
        pot: '中转港',
        pot1: '中转港 (1st)',
        pot2: '中转港 (2nd)',
        pot3: '中转港 (3rd)',
        carrierId: '船公司',
        carrierCode: '船公司',
        contractNo: '约号',
        laneId: '航线',
        laneCode: '航线代码',
        directFlag: '直达/中转',

        // 状态筛选
        spaceStatus: '舱位状态',
        status: '运价状态',
        priceTrend: '价格趋势',

        // 货物信息筛选
        cargoType: '货物类型',
        spaceNature: '舱位性质',
        specialPriceStatus: '特价状态',
        laneType: '航线类型',
        containerOwnership: '箱属',

        // 船期信息筛选
        weekdays: '船期',
        vessel: '船名',
        voyage: '航次',
        voyageDays: '航程天数',

        // 时间筛选
        beginDate: '生效日期',
        endDate: '失效日期',
        etd: 'ETD',
        eta: 'ETA',
        dateCreated: '创建时间',
        dateModified: '修改时间',

        // 其他筛选
        detentionFreeDays: '免用箱期',
        demurrageFreeDays: '免堆存期',
        nac: 'NAC',
        remarks: '备注',
        createdBy: '创建人',
        por: '收货地',
        pdl: '目的港',
        modifiedBy: '修改人'
      },

      // 占位符
      placeholders: {
        priceNo: '请输入运价号',
        freightType: '请选择运价类型',
        pol: '请选择起运港',
        pod: '请选择卸货港',
        pot: '请选择中转港',
        podRouteCategory: '请选择卸货港航线分类',
        pot2: '请选择中转港 (2nd)',
        pot3: '请选择中转港 (3rd)',
        cutoffWeekdays: '请选择截关班期',
        unboxDelivery: '请选择拆柜派送',
        freightCurrency: '请选择币种',
        freightPaymentType: '请选择付费条款',
        batchNo: '请输入批次号',
        carrierId: '请选择船公司',
        carrierCode: '请选择船公司',
        contractNo: '请选择约号',
        laneId: '请选择航线',
        supplier: '请选择供应商',
        transportTerm: '请选择运输条款',
        tradeTerms: '请选择贸易条款',
        laneCode: '请输入航线代码',
        directFlag: '请选择直达/中转',
        spaceStatus: '请选择舱位状态',
        status: '请选择运价状态',
        priceTrend: '请选择价格趋势',
        cargoType: '请选择货物类型',
        spaceNature: '请选择舱位性质',
        specialPriceStatus: '请选择特价状态',
        laneType: '请选择航线类型',
        containerOwnership: '请选择箱属',
        weekdays: '请选择船期',
        vessel: '请输入船名',
        voyage: '请输入航次',
        voyageDays: '请输入航程天数',
        detentionFreeDays: '请输入免用箱期（天）',
        demurrageFreeDays: '请输入免堆存期（天）',
        nac: '请选择NAC',
        beginDate: '请选择生效日期范围',
        endDate: '请选择失效日期范围',
        etd: '请选择ETD范围',
        eta: '请选择ETA范围',
        remarks: '请输入备注',
        createdBy: '请输入创建人',
        dateCreated: '请选择创建时间范围',
        modifiedBy: '请输入修改人',
        por: '收货地',
        pdl: '目的港',
        dateModified: '请选择修改时间范围'
      },

      // 表格列
      columns: {
        // 基础信息列
        priceNo: '运价号',
        pricingNature: '约价性质',
        freightType: '运价类型',
        por: '收货地',
        placeOfDelivery: '收货地',
        pol: '起运港',
        pdl: '目的港',
        portOfDischarge: '目的地',
        pod: '卸货港',
        podRouteCategory: '卸货港航线',
        batchNo: '批次号',
        laneId: '航线',
        laneCode: '航线代码',
        pot: '中转港',
        pot1: '中转港 (1st)',
        pot2: '中转港 (2nd)',
        pot3: '中转港 (3rd)',
        directFlag: '直达/中转',
        directFlag2: '直达/中转',
        carrierId: '船公司',
        contractNo: '约号',

        // 状态列
        spaceStatus: '舱位状态',
        priceTrend: '价格趋势',
        status: '状态',

        // 货物信息列
        cargoType: '货物类型',
        spaceNature: '舱位性质',
        specialPriceStatus: '特价状态',
        laneType: '航线类型',
        containerOwnership: '箱属',

        // 船期信息列
        shippingSchedule: '船期',
        voyage: '航程',
        vesselName: '船名',
        voyageNo: '航次',

        // 时间信息列
        validPeriod: '有效期',
        etd: 'ETD',
        eta: 'ETA',
        cutoffDate: '截关日',
        beginDate: '生效日期',
        endDate: '失效日期',
        createDate: '创建日期',
        modifyDate: '修改日期',

        // 费用信息列
        freeStorageDays: '免用箱',
        demurrageFreeDays: '免堆存',
        nac: 'NAC',

        // 箱型价格列
        gp20: '20GP',
        gp40: '40GP',
        hc20: '20HC',
        hc40: '40HC',
        hc45: '45HC',
        nor20: '20NOR',
        nor40: '40NOR',
        tk20: '20TK',
        tk40: '40TK',
        ot20: '20OT',
        ot40: '40OT',
        fr20: '20FR',
        fr40: '40FR',
        hq40: '40HQ',
        hq45: '45HQ',
        rf20: '20RF',
        rf40: '40RF',
        cost: '成本',
        sell: '卖价',
        currency: '分币种',

        // 其他信息列
        destinationRegion: '目的区域',
        entryPerson: '创建人',
        rateModifier: '修改人',
        rateStatus: '状态',
        routeName: '航线名称',
        routeCode: '航线代码',
        terminal: '码头',
        branch: '分公司',
        supplier: '供应商',
        cargoDescription: '货物描述',
        transportTerm: '运输条款',
        tradeTerms: '贸易条款',
        polTerminal: '起运港码头',
        podTerminal: '卸货港码头',
        cutoffWeekdays: '截关班期',
        unboxDelivery: '拆柜派送',
        weightLimit: '限重',
        receivingInstructions: '收货说明',
        onePrice: '一口价',
        freightCurrency: '海运费币种',
        freightPaymentType: '付费条款',
        remarks: '备注',
        dateCreated: '创建时间',
        actions: '操作'
      },

      // 星期几
      weekdays: {
        monday: '周一',
        tuesday: '周二',
        wednesday: '周三',
        thursday: '周四',
        friday: '周五',
        saturday: '周六',
        sunday: '周日'
      },

      // 操作按钮
      actions: {
        add: '新增整箱运价',
        import: '标准导入',
        importTooltip: '仅支持系统指定模板格式',
        export: '导出',
        downloadTemplate: '下载导入模板',
        aiParsing: 'AI解析',
        aiParsingTooltip: '支持任意格式，AI 自动识别解析数据',
        aiRecognition: 'AI识别',
        batchModify: '批量修改',
        batchOperations: '批量操作',
        batchOnShelf: '批量上架',
        batchOffShelf: '批量下架',
        batchPriceChange: '批量改价',
        batchValidityChange: '批量改时间',
        batchDelete: '批量删除',
        view: '详情',
        edit: '编辑',
        more: '更多',
        copy: '复制',
        onShelf: '上架',
        offShelf: '下架',
        delete: '删除'
      },

      // 枚举值
      enums: {
        // 运价类型
        rateTypes: {
          contract: '合约价',
          spot: 'SPOT电商',
          peer: '同行价',
          ratio: '配比价'
        },

        // 直达/中转
        transitTypes: {
          direct: '直达',
          transit: '中转'
        },

        // 舱位状态
        spaceStatus: {
          smooth: '畅接',
          normal: '正常',
          singleApply: '单票申请',
          overbooked: '爆舱',
          notAccepting: '不接',
          limited: '紧张',
          suspended: '停航',
          inquiry: '询盘'
        },

        // 价格趋势
        priceTrends: {
          rising: '价格上涨',
          falling: '价格下调',
          stable: '价格稳定'
        },

        // 运价状态
        status: {
          draft: '待上架',
          normal: '正常',
          published: '发布',
          expired: '失效',
          invalid: '失效',
          offline: '下架',
          disabled: '禁用',
          pendingImport: '待导入'
        },

        // 货物类型
        cargoTypes: {
          general: '普货',
          dangerous: '危险品',
          frozen: '冷冻品',
          special: '特种箱',
          steelCoil: '卷钢',
          liquid: '液体',
          chemical: '化工品',
          textile: '纺织品'
        }
      },
      status: {
        draft: '待上架',
        normal: '正常',
        expired: '失效',
        offline: '下架'
      },
      confirm: {
        onShelf: '确认上架',
        offShelf: '确认下架',
        delete: '确认删除',
        onShelfContent: '确定要将该运价上架吗？',
        offShelfContent: '确定要将该运价下架吗？',
        deleteContent: '确定要删除该运价吗？'
      },

      // 批量操作
      batch: {
        selected: '已选择 {count} 项',
        onShelfConfirm: '确定要将选中的 {count} 条运价上架吗？',
        offShelfConfirm: '确定要将选中的 {count} 条运价下架吗？',
        deleteConfirm: '确定要删除选中的 {count} 条运价吗？此操作不可恢复。',
        onShelfSuccess: '成功上架 {count} 条运价',
        offShelfSuccess: '成功下架 {count} 条运价',
        deleteSuccess: '成功删除 {count} 条运价',

        // 批量改价
        priceChange: {
          title: '批量改价',
          selectedRates: '已选择 {count} 条运价',
          operationReminder: '操作提醒',
          reminderContent: '此操作会修改所有选中运价的费用金额，请谨慎操作。您可以选择特定的费用类型进行批量修改。置空代表该箱型价格不变，原运价如不存在对应箱型价格，则调整不会生效。请先选择涨价还是降价，输入框里永远只输入正整数。',
          selectCharge: '选择费用',
          selectChargeDesc: '选择要批量修改价格的费用类型，如海运费、操作费等。',
          selectChargePlaceholder: '请选择要修改的费用类型',
          selectPriceMode: '选择改价模式',
          priceIncrease: '涨价',
          priceDecrease: '降价',
          setPriceMode: '固定金额',
          priceIncreaseDesc: '选择涨价模式，输入框中填写涨价金额（正整数）',
          priceDecreaseDesc: '选择降价模式，输入框中填写降价金额（正整数）',
          setPriceDesc: '选择固定金额模式，输入其中任意箱型的价格（正整数）',
          setPrice: '设置价格',
          selectChargeFirst: '请先选择费用类型，然后设置价格',
          rateListToModify: '将被修改的运价列表',
          rateDetailsList: '待修改运价列表',
          rateNo: '运价号',
          pol: '起运港',
          pod: '卸货港',
          carrier: '船公司',
          status: '状态',
          showChargePrice: '（显示{charge}价格）',
          showAllCharges: '（显示所有按箱型计费费用的总计价格）',
          noData: '暂无数据',
          selectedSummary: '共选择 {count} 条运价，将批量修改{type}的价格。',
          currentChargeType: '当前选择费用类型：',
          confirmOperation: '此操作会修改选中运价的',
          confirmOperationSuffix: '金额，请确认数据准确性',
          selectChargeAndPrice: '请先选择费用类型和设置价格，然后确认修改',
          confirm: '确认',
          cancel: '取消',
          batchPriceSuccess: '批量改价成功',
          batchPriceFailed: '批量改价失败',
          batchPriceError: '批量改价出错',
          pricePlaceholders: {
            increase: '涨价金额',
            decrease: '降价金额',
            setPrice: '固定价格',
            default: '输入价格'
          },
          freightInfo: '海运费信息',
          freightCurrency: '币种',
          freightCurrencyPlaceholder: '如 USD',
          freightPaymentType: '付费条款',
          freightPaymentTypePlaceholder: '请选择',
          freightEqPrice: '海运费箱型价格',
          freightInfoDesc: '留空表示不修改，箱型价格将直接覆盖主表海运费。',
          confirmFreightOperation: '此操作将更新选中运价的海运费信息，请确认数据准确性',
          selectChargeOrFreight: '请选择费用类型或填写海运费信息，然后确认修改'
        },

        // 统一批量修改
        modify: {
          title: '批量修改',
          selectedRates: '已选择 {count} 条运价',
          filterScope: '当前筛选结果',
          reminder: '仅未发布（状态非“已发布”）的运价允许修改；已发布的运价将被自动跳过。未填写的普通字段保持不变。特殊字段选择“清空”后会清除原值。',
          leftSection: '费用与有效期',
          rightSection: '港口与船期',
          costTitle: '成本价(基础海运费)',
          costDesc: '+ 在现价加上调整金额 | - 减去调整金额 | = 用调整金额直接替换价格',
          containerType: '箱型',
          operation: '操作',
          adjustmentAmount: '调整金额',
          amountPlaceholder: '请输入金额',
          keywordPlaceholder: '请输入关键字',
          inputPlaceholder: '请输入',
          selectPlaceholder: '请选择',
          delete: '删除',
          addContainer: '添加箱型',
          confirm: '确定',
          clearOption: '置空',
          freightEqPrice: '基础海运费成本价',
          priceMode: '成本价操作',
          increase: '增加',
          decrease: '减少',
          setPrice: '设置为',
          pricePlaceholder: '留空表示不修改',
          validDate: '运价有效期',
          priceTrend: '价格趋势',
          priceTrendPlaceholder: '请选择价格趋势',
          specialPriceStatus: '特价申请',
          specialPricePlaceholder: '请选择特价状态',
          transportTerm: '运输条款',
          transportTermPlaceholder: '请选择运输条款',
          modify: '修改为',
          clear: '清空',
          valuePlaceholder: '请输入修改值',
          transferPortInfo: '中转港',
          receivingInstructions: '特殊接货说明',
          remarks: '备注',
          overweightRemarks: '限重',
          detentionFreeDays: '滞箱费',
          demurrageFreeDays: '滞港费',
          por: '收货地',
          pdl: '目的港',
          pol: '起运港',
          polTerminalId: '起运港码头',
          pod: '卸货港',
          podTerminalId: '卸货港码头',
          vessel: '船名',
          voyage: '航次',
          laneCode: '航线代码',
          voyageDays: '航程',
          portPlaceholder: '请选择港口',
          terminalPlaceholder: '请选择码头',
          textPlaceholder: '留空表示不修改',
          numberPlaceholder: '请输入非负数',
          datePlaceholder: ['开始日期', '结束日期'],
          submit: '确认修改',
          cancel: '取消',
          noChange: '请至少填写一个需要修改的字段',
          invalidDate: '开始日期不能晚于结束日期',
          duplicateContainer: '箱型不能重复',
          allContainersAdded: '已添加全部可用箱型',
          success: '批量修改成功：{count} 条',
          partialSuccess: '批量修改完成：成功 {success} 条，跳过 {skipped} 条，失败 {failed} 条',
          failed: '批量修改失败：{failed} 条',
          noData: '没有找到符合条件（未发布）的运价记录',
          networkError: '批量修改请求失败，请稍后重试'
        },

        // 批量改时间
        timeChange: {
          title: '批量改时间',
          operationReminder: '操作提醒',
          reminderContent: '此处批量修改仅针对选中运价的日期信息，请谨慎操作。',
          etdTab: 'ETD (预计开船日)',
          etaTab: 'ETA (预计到港日)',
          validDateTab: '有效期',
          setNewEtd: '设置新的ETD (预计开船日)',
          setNewEta: '设置新的ETA (预计到港日)',
          setNewValidDate: '设置新的有效期',
          newEtd: '新ETD:',
          newEta: '新ETA:',
          validPeriod: '有效期:',
          selectEtd: '选择预计开船日',
          selectEta: '选择预计到港日',
          selectEtaPlaceholder: '请选择预计到港日',
          selectValidDateRange: '请选择有效期范围',
          invalidDateRange: '开始日期不能大于结束日期',
          startDate: '开始日期',
          endDate: '结束日期',
          currentEtd: '当前ETD',
          currentEta: '当前ETA',
          currentValidPeriod: '当前有效期',
          selectedSummary: '共选择 {count} 条运价，将批量修改 {type} 信息',
          selectedRatesList: '将被修改的运价列表',
          etdUpdateSuccess: '成功修改 {count} 条运价的ETD',
          etaUpdateSuccess: '成功修改 {count} 条运价的ETA',
          validDateUpdateSuccess: '成功修改 {count} 条运价的生效期',
          updateFailed: '批量修改时间失败',
          tipText: '注意：修改后的日期将立即生效，请确认数据准确。',
          validDate: '有效期'
        }
      },

      // 费用项目
      chargeItems: {
        oceanFreight: '海运费',
        operationFee: '操作费',
        documentationFee: '文件费',
        portCharges: '港杂费',
        storageFee: '仓储费',
        inlandTransport: '内陆运费',
        customsFee: '报关费',
        insuranceFee: '保险费',
        baf: '燃油附加费',
        caf: '货币调节费',
         // 批量操作消息
        messages: {
          loadDataFailed: '数据加载失败',
          loadDetailFailed: '加载运价明细失败',
          onShelfSuccess: '上架成功'
        },
        detentionFee: '超期用箱费',
        demurrageFee: '免堆期超期费',
        additionalFee: '附加费',
        fuelFee: '燃油费',
        bookingFee: '订舱费',
        inspectionFee: '商检费',
        trailerFee: '拖车费'
      },

      // AI识别
      aiRecognition: {
        title: 'AI智能识别',
        uploadTitle: '上传合约文件',
        uploadDesc: '点击或拖拽文件到此区域，系统将自动识别内容并提取运价信息',
        processing: 'AI正在识别中...',
        processingDesc: '请稍候，AI正在分析您的运价文件...',
        success: '识别成功！',
        successDesc: '运价信息已成功识别并导入',
        error: '识别失败',
        errorDesc: '文件识别失败，请检查文件格式或重新上传',
        retry: '重新上传',
        // AI识别说明
        aiDescription: 'AI识别说明',
        aiFeatures: [
          'AI将自动识别运价表格中的港口、船公司、价格等信息',
          '支持多种文件格式 and 复杂表格结构',
          '识别完成后会创建后台任务进行处理',
          '请确保上传的文件清晰可读'
        ],
        // 成功提示
        successTitle: 'AI识别任务已提交',
        successDescription: '当前任务后台正在运行中，请到<strong>系统设置 - 任务管理</strong>中查看任务进度和结果。',
        goToTaskManagement: '前往任务管理',
        close: '关闭',
        // 上传相关
        uploadFile: '上传{type}文件',
        clickOrDrag: '点击或拖拽文件到此区域上传',
        supportedFormats: '支持格式：PDF、Excel、Word、图片等',
        selectFile: '选择文件',
        aiParsing: 'AI解析中...',
        aiParsingTip: 'AI正在解析文档，请稍候...',
        // 合约解析（VAS）跳转
        contractParsingNotActivated: '合约解析未开通',
        contractParsingRequired: '请联系销售 13524664368（同微信）',
        contractParsingUrlMissing: '合约解析页面地址未配置',
        contractParsingCheckFailed: '合约解析开通状态查询失败，请稍后重试'
      },

      // 详情页
      detail: {
        // 页面标题
        pageTitles: {
          create: '新增整箱运价',
          edit: '编辑整箱运价',
          view: '运价详情',
          copy: '复制整箱运价'
        },

        placeholder: '请选择',

        // 按钮文本
        buttons: {
          back: '返回',
          cancel: '取消',
          saveDraft: '保存草稿',
          save: '保存',
          saveAndQuote: '保存并报价',
          directOnShelf: '直接上架',
          aiRecognition: 'AI识别',
          edit: '编辑',
          copy: '复制',
          addContainerType: '添加箱型'
        },

        // 提示文案
        hints: {
          salePriceAuto: '自动计算，可手动覆盖',
          freightPriceMin: '至少填写一个箱型成本价'
        },

        // 复制模式提示
        copyMode: {
          alert: '正在复制运价信息，运价编号将自动重新生成，请确认所有信息后保存'
        },

        // 运价状态
        status: {
          label: '运价状态：',
          draft: '待上架',
          normal: '正常',
          expired: '过期',
          offShelf: '下架',
          offline: '下架',
          unknown: '未知'
        },

        // 章节标题
        sections: {
          basicInfo: '基本信息',
          routeInfo: '航线信息',
          carrierInfo: '船公司信息',
          validitySettings: '有效期设置',
          remarks: '备注信息',
          rateDetails: '运价明细',
          rateInfo: '运价信息',
          oceanFreight: '海运费',
          oceanFreightSurcharge: '海运附加费',
          polSurcharge: '起运港费用',
          podSurcharge: '卸货港费用',
          increaseRule: '加价规则',
          surchargeDetails: '附加费明细'
        },

        // 徽标
        badges: {
          matched: '已匹配'
        },
        // 表单字段
        fields: {
          priceNo: '运价号',
          batchNo: '批次号',
          rateType: '运价类型',
          placeOfDelivery: '收货地',
          pol: '起运港',
          polTerminal: '起运港码头',
          podTerminal: '卸货港码头',
          portOfDischarge: '卸货港',
          pod: '卸货港',
          podRouteCategory: '卸货港航线',
          laneId: '航线',
          laneCode: '航线代码',
          shipName: '船名',
          voyageNumber: '航次',
          departureWeekdays: '开航班期',
          cutoffWeekdays: '截关班期',
          unboxDelivery: '拆柜派送',
          weightLimit: '限重',
          freightCurrency: '币种',
          freightPaymentType: '付费条款',
          onePrice: '一口价',
          containerType: '箱型',
          costPrice: '成本价',
          salePrice: '销售卖价',
          etd: 'ETD',
          eta: 'ETA',
          vesselSchedule: '船期',
          voyage: '航程',
          pot1: '中转港 (1st)',
          pot2: '中转港 (2nd)',
          pot3: '中转港 (3rd)',
          carrier: '船公司',
          contractNo: '约号',
          nac: 'NAC',
          freeContainerDays: '免用箱',
          freeStorageDays: '免堆存',
          validPeriod: '有效期',
          overweightNote: '超重说明',
          chargeSpecialNote: '接货特殊说明',
          notes: '备注',
          ruleName: '规则名称',
          rulesId: '规则ID',
          increasePriceType: '加价类型',
          increasePercentage: '加价比例',
          markupAmount: '加价金额',
          branch: '分公司',
          cargoDescription: '货物描述',
          tradeTerms: '贸易条款',
          detentionFreeDays: '目的港免柜期',
          demurrageFreeDays: '目的港免堆期',
          por: '收货地',
          pdl: '目的港'
        },

        // 占位符
        placeholders: {
          selectRateType: '请选择运价类型',
          selectPlaceOfDelivery: '请选择收货地',
          selectPol: '请选择起运港',
          selectPolTerminal: '请选择起运港码头',
          selectPodTerminal: '请选择卸货港码头',
          selectPortOfDischarge: '请选择卸货港',
          selectPdl: '请选择目的港',
          selectPod: '请选择卸货港',
          selectPodRouteCategory: '请选择卸货港航线',
          selectLaneId: '请选择航线',
          inputLaneCode: '请输入航线代码',
          inputShipName: '请输入船名',
          inputVoyage: '请输入航次',
          inputVoyageNumber: '请输入航次',
          selectDepartureWeekdays: '请选择开航班期',
          selectCutoffWeekdays: '请选择截关班期',
          selectUnboxDelivery: '请选择拆柜派送',
          inputWeightLimit: '请输入限重',
          selectFreightCurrency: '请选择币种',
          selectFreightPaymentType: '请选择付费条款',
          selectOnePrice: '请选择一口价',
          inputCostPrice: '请输入成本价',
          autoCalculate: '自动计算',
          selectEtd: '请选择预计开船日',
          selectEta: '请选择预计到港日',
          selectVesselSchedule: '请选择船期',
          copyPriceNo: '复制后将重新生成，格式：FCL2506250001',
          autoGeneratePriceNo: '后端自动生成，格式：FCL2506250001',
          selectPot1: '请选择中转港 (1st)',
          selectPot2: '请选择中转港 (2nd)',
          selectPot3: '请选择中转港 (3rd)',
          selectCarrier: '请选择船公司',
          selectContractNo: '请选择约号',
          selectNac: '请选择NAC',
          inputFreeContainerDays: '请输入免用箱(天)',
          inputFreeStorageDays: '请输入免堆存(天)',
          startDate: '开始日期',
          endDate: '结束日期',
          inputOverweightNote: '请输入超重说明',
          inputChargeSpecialNote: '请输入接货特殊说明',
          inputNotes: '请输入备注',
          selectFeeName: '请选择费用名称',
          autoFill: '自动填充',
          inputContainerPrice: '请输入价格',
          selectBillingUnit: '请选择计费单位',
          inputSpecialNote: '请输入特殊备注',
          selectBranch: '请选择分公司',
          inputCargoDescription: '请输入货物描述',
          selectTradeTerms: '请选择贸易条款',
          inputDetentionFreeDays: '请输入目的港免柜期',
          inputDemurrageFreeDays: '请输入目的港免堆期'
        },

        // 表单验证消息
        validation: {
          selectPot1: '请选择中转港 (1st)',
          selectCarrier: '请选择船公司',
          selectValidPeriod: '请选择有效期',
          selectBranch: '请选择分公司',
          selectTradeTerms: '请选择贸易条款',
          selectSupplier: '请选择供应商',
          selectCargoType: '请选择货物类型',
          selectSpaceStatus: '请选择舱位状态',
          selectSpecialPriceStatus: '请选择特价状态',
          selectPriceTrend: '请选择价格趋势',
          selectContainerOwnership: '请选择箱属',
          selectFreightCurrency: '请选择海运费币种',
          selectFreightPaymentType: '请选择付费条款',
          selectPlaceOfDeliveryOrPol: '收货地/起运港至少填写一项',
          selectPortOfDischargeOrPod: '卸货港/目的港至少填写一项'
        },

        // 消息提示
        messages: {
          selectRateType: '请选择运价类型',
          selectPol: '请选择起运港',
          selectPod: '请选择卸货港',
          selectLaneId: '请选择航线',
          saveDataFirst: '请先保存数据',
          onlyDraftCanSave: '只有草稿状态的运价才能保存',
          onlyDraftCanSaveDraft: '只有草稿状态的运价才能保存草稿',
          draftSaveSuccess: '草稿保存成功',
          draftSaveFailed: '保存草稿失败',
          rateUpdateSuccess: '运价更新成功！',
          rateCreateSuccess: '运价创建成功！',
          rateUpdateAndOnShelfSuccess: '运价更新并上架成功！',
          rateCreateAndOnShelfSuccess: '运价创建并上架成功！',
          saveAndQuoteSuccess: '运价已保存并生成商务报价',
          missingInquiryId: '缺少询价 ID，无法保存并报价',
          copySuccess: '已复制运价信息到新增页面，运价编号将重新生成，请确认信息后保存',
          saveFailed: '保存失败',
          checkRequiredFields: '请检查必填项',
          unknownError: '未知错误',
          loadDataFailed: '加载数据失败',
          copyDataLoadFailed: '复制数据加载失败',
          unknownFee: '未知费用',
          getBasicFeeFailed: '未获取到基础费用',
          containerSettingsUpdated: '箱型设置已更新',
          loadFeeDataFailed: '加载费用数据失败',
          feeTypeRequired: '第{row}行：请选择费用位置类型',
          atLeastOneContainerType: '第{row}行：按箱计费至少需要填写一个箱型价格',
          unitRateRequired: '第{row}行：按票计费单价不能为空'
        },

        // 弹窗
        modals: {
          containerSettings: '箱型设置',
          aiRecognition: 'AI智能识别运价'
        },

        // 运价明细
        rateDetails: {
          title: '运价明细',
          containerBilling: '按箱型计费',
          nonContainerBilling: '非按箱型计费',
          boxTypeSettings: '箱型设置',
          addItem: '添加项目',
          basicFee: '基础费用',
          delete: '删除',
          noData: '暂无数据',

          // 表格列标题
          tableColumns: {
            feeName: '费用名称',
            currency: '币种',
            billingUnit: '计费单位',
            unitPrice: '单价',
            specialNote: '特殊备注',
            actions: '操作',
            unitRate: '费用(票)',
            paymentType: '付费条款',
            feeType: '费用类型',
            rowSource: '来源',
            surchargeNo: '附加费ID',
            surchargeValidPeriod: '有效期',
            rowSourceManual: '手动创建',
            rowSourceSystem: '系统规则'
          },
          containerBillingTitle: '按箱型计费',
          feeNameTitle: '费用名称',
          specialNoteTitle: '特殊备注',
          currencyTitle: '币种',
          unitTitle: '计费单位',
          priceTitle: '单价',
          mainline: '干线',
          containerBillingLabel: '按箱计费',
          nonContainerBillingLabel: '非按箱计费'
        },

        // 状态标签
        statusLabels: {
          rateStatus: '运价状态：'
        },

        // 按钮文本
        buttonTexts: {
          back: '返回'
        },

        // 枚举值标签
        enumLabels: {
          // 运价类型
          rateTypes: {
            contract: '合约价',
            spot: 'SPOT电商'
          },

          // 货物类型
          cargoTypes: {
            general: '普货',
            dangerous: '危险品',
            frozen: '冷冻品',
            special: '特种箱',
            steelCoil: '卷钢',
            liquid: '液体',
            chemical: '化工品',
            textile: '纺织品'
          },

          // 舱位状态
          spaceStatus: {
            smooth: '畅接',
            normal: '正常',
            singleApply: '单票申请',
            overbooked: '爆舱',
            notAccepting: '不接',
            limited: '紧张',
            suspended: '停航',
            inquiry: '询盘'
          },

          // 价格趋势
          priceTrends: {
            rising: '价格上涨',
            falling: '价格下调',
            stable: '价格稳定'
          },

          // 运输方式
          transitTypes: {
            direct: '直达',
            transit: '中转'
          }
        },

        // 中转港相关
        transitPorts: {
          first: '中转港 (1st)',
          second: '中转港 (2nd)',
          third: '中转港 (3rd)',
          selectFirst: '请选择第一中转港',
          selectSecond: '请选择第二中转港',
          selectThird: '请选择第三中转港'
        },

        // 费用名称映射
        feeNames: {
          documentFee: '文件费'
        },

        // 模态框详细内容
        modalContent: {
          boxTypeSettings: {
            description: '选择要在运价表格中显示的箱型：'
          },
          aiRecognition: {
            uploadTitle: '上传运价文件',
            uploadDesc: '点击或拖拽文件到此区域上传',
            supportedFormats: '支持格式：PDF、Excel、Word、图片等',
            selectFile: '选择文件',
            aiDescription: 'AI识别说明',
            aiFeatures: [
              'AI将自动识别运价表格中的港口、船公司、价格等信息',
              '支持多种文件格式 and 复杂表格结构',
              '识别完成后会创建后台任务进行处理',
              '请确保上传的文件清晰可读'
            ]
          }
        },

        // 消息提示
        notifications: {
          aiRecognitionSuccess: 'AI识别完成，已自动填充运价信息！',
          fileUploadPending: '文件上传功能开发中...'
        },
        // 批量操作确认
        confirm: {
          onShelf: '确认上架',
          offShelf: '确认下架',
          delete: '确认删除',
          onShelfContent: '确定要将该运价上架吗？',
          offShelfContent: '确定要将该运价下架吗？',
          deleteContent: '确定要删除该运价吗？'
        }
      },

      // 消息提示
      messages: {
        loadDataFailed: '数据加载失败',
        addSuccess: '新增成功',
        editSuccess: '编辑成功',
        deleteSuccess: '删除成功',
        copySuccess: '复制成功',
        onShelfSuccess: '上架成功',
        offShelfSuccess: '下架成功',
        batchOnShelfFailed: '批量上架失败',
        batchOffShelfFailed: '批量下架失败',
        batchDeleteFailed: '批量删除失败',
        batchPriceFailed: '批量改价失败',
        batchTimeFailed: '批量改时间失败',
        deleteConfirm: '确定要删除这条运价记录吗？',
        exportFilename: 'FCL整箱运价数据',
        unknown: '未知',
        selectTransitType: '请选择运输方式',
        viewDetailFailed: '无法查看详情：缺少记录ID',
        editFailed: '无法编辑：缺少记录ID',
        copyFailed: '无法复制：缺少记录ID',
        loadRateDetailsFailed: '加载运价明细失败',
        selectFeeTypeFirst: '请先选择费用类型',
        inputAtLeastOnePrice: '请至少输入一个箱型的价格',
        all: '所有',
        onlyDraftCanOnline: '只有草稿状态的运价才能上架，当前选中包含：{status} 状态的运价',
        onlyNormalCanOffline: '只有已发布状态的运价才能下架，当前选中包含：{status} 状态的运价',
        onlyDraftCanDelete: '只有草稿状态的运价才能删除，当前选中包含：{status} 状态的运价',
        onlyDraftCanModify: '只能修改草稿状态的运价，请重新选择',
        importTitle: '导入整箱运价',
        importDesc: '请上传 FCL3.1 模板的 Excel 文件（.xls / .xlsx），系统将校验表头与结构并解析数据行。',
        importSelectFile: '选择文件',
        importSubmit: '开始导入',
        importSelectFileFirst: '请先选择要上传的文件',
        importParsing: '正在上传并校验…',
        importSuccess:
          '解析：{sheetCount} 个工作表，共 {totalRows} 行；落库成功 {savedSuccess} 条、失败 {savedFailed} 条；空行 {skipped} 条。批次号：{batchNo}',
        importFailed: '导入失败',
        templateDownloadFailed: '模板下载失败',
        importReminderTitle: '功能提示',
        importReminderLine1: '1. 运费将存入相应的草稿包，上架后生效。',
        importReminderLine2: '2. 如果在该期间有对应的价格，则会覆盖原有价格。',
        loadFeeCacheFailed: '加载费用数据失败',
        feeTypeFallback: '费用类型 {feeType}',
        onlyDraftCanOnlineDetail: '只有草稿、已失效或已下架状态的运价才能上架，当前选中包含：{status} 状态的运价',
        onlyNormalCanOfflineDetail: '只有已发布状态的运价才能下架，当前选中包含：{status} 状态的运价',
        onlyDraftCanDeleteDetail: '只有草稿状态的运价才能删除，当前选中包含：{status} 状态的运价',
        onlyDraftCanModifyDetail: '只能修改草稿状态的运价，当前选中包含：{status} 状态的运价，请重新选择',
        disabledStatusOnlineFailed: '该运价已被禁用，无法直接上架',
        statusToggleFailed: '上下架操作失败',
        statusToggleForbidden: '{status}状态的运价不能进行上下架操作',
        loadRateDetailFailed: '加载运价明细失败',
        selectContainerTypeFirst: '请选择要调整的箱型',
        atLeastOneContainerConfig: '至少需要保留一个箱型配置',
        containerTypeAlreadySelected: '该箱型已被选择，请选择其他箱型',
        toggleStatusFailed: '状态切换失败，请重试',
        exportSuccess: '导出成功',
        exportFailed: '导出失败'
      },
      ratio: {
        actions: {
          ratio: '运价配比',
          generate: '生成',
          saveDraft: '保存草稿',
          clearDraft: '清空草稿',
          addRow: '新增源',
          removeRow: '删除',
          downloadUnmatched: '下载未匹配明细',
          goToList: '前往运价维护',
          reload: '重新加载'
        },
        modal: {
          title: '运价配比',
          sourceTitle: '配比源（2-3 个，至少 1 FAK + 1 Name Account (Fix)）',
          colSort: '序号',
          colBatchNo: '源批次号',
          colWeight: '配比权重',
          colContractNo: '合约号',
          colNature: '约价性质',
          colPodRoute: '卸货港航线分类',
          colPdl: '目的港',
          colPriceRange: '价格有效期',
          effectiveRange: '配比运价有效期',
          weightPlaceholder: '0-9.9',
          batchPlaceholder: '请输入批次号',
          contractPlaceholder: '请输入合约号',
          naturePlaceholder: '请选择约价性质',
          podRoutePlaceholder: '请选择航线',
          pdlPlaceholder: '请选择目的港',
          effectiveMismatchTitle: '有效期不一致提醒',
          effectiveMismatchContent: '原手动维护的运价有效期起止时间（{origBegin} ~ {origEnd}）与此处填写的时间（{curBegin} ~ {curEnd}）不一致。',
          comboOnShelfWarn: '当前合约组合已有生效中的配比价，继续执行将生成草稿，上架前需先下架原批次',
          noOverlapWarn: '所选批次有效期无重叠，请手动指定配比运价有效期',
          draftLoaded: '已加载未完成草稿',
          draftSaved: '草稿已保存',
          draftCleared: '草稿已清空',
          duplicateBatchWarn: '源批次号不能重复',
          duplicateContractWarn: '合约号不能重复',
          duplicateSourceWarn: '存在重复的源批次号或合约号',
          hasInvalidRowWarn: '存在获取信息失败的源，请修正或删除',
          minSourcesWarn: '至少需要配置 2 个配比源',
          missingWeightWarn: '请为所有源输入有效的配比权重 (0.1-9.9)',
          missingNatureWarn: '请完善所有源的约价性质',
          comboNatureWarn: '配比源必须至少包含 1 个 FAK 与 1 个 Name Account (Fix)',
          carrierMismatchWarn: '所有合约必须属于同一家船公司，当前包含不同船司合约，不允许保存草稿或生成配比',
          missingEffectiveRangeWarn: '请选择配比运价有效期',
          missingNatureTopTip: '部分合约约价性质不符、未维护或未建档，允许保存草稿；生成配比前须前往合约管理维护。',
          missingNatureDialogTitle: '无法生成配比：合约约价性质不满足要求',
          promptDialogDesc: '以下配比源合约未维护合法约价性质，无法生成配比。运价配比仅支持 FAK 或 Name Account (Fix/BCO) 性质的合约，请前往【合约管理】维护后再试：',
          promptCaseNotFound: '合约号【{contractNo}】：在合约管理中不存在，请前往新增合约。',
          promptCaseNatureMissing: '合约号【{contractNo}】：合约已存在但未维护约价性质，请前往补充为 FAK 或 BCO合约。',
          promptCaseNatureIncompatible: '合约号【{contractNo}】：当前性质为【{nature}】，配比仅支持 FAK 或 Name Account (BCO合约)，请前往修改。',
          promptDraftNote: '提示：点击下方“前往合约管理”将自动为您暂存当前配置草稿。',
          tagNatureMissing: '未维护性质',
          tagNatureIncompatible: '性质不符: {nature}',
          tagContractNotFound: '合约未建档',
          tipNatureMissing: '合约已存在但未维护约价性质，生成配比前需补充',
          tipNatureIncompatible: '当前性质为【{nature}】，配比仅支持 FAK 或 Name Account (BCO合约)，生成配比前需修改',
          tipContractNotFound: '合约在合约管理中不存在，生成配比前需新增',
          actionSupplement: '去补充',
          actionModify: '去修改',
          actionAddContract: '去新增',
          goToContractManagement: '前往合约管理',
          refreshCheck: '刷新/重新校验',
          tipRefresh: '重新校验合约性质',
          natureRefreshedSuccess: '合约号【{contractNo}】性质已更新为：{nature}',
          natureStillMissing: '合约号【{contractNo}】已存在，但合约性质仍未维护',
          natureStillIncompatible: '合约号【{contractNo}】性质仍为【{nature}】，仍不满足配比要求（仅支持 FAK 或 BCO合约）',
          contractStillNotFound: '合约号【{contractNo}】在合约管理中仍未查到'
        },
        progress: {
          title: '配比任务进度',
          completedTitle: '配比运价已完成',
          completedSubtitle: '运算结果已自动导入【运价维护】，可通过下方任务ID搜索该批配比运价',
          processingTitle: '配比运价处理中',
          processingSubtitle: '正在执行运价配比，请稍候...',
          failedTitle: '配比运价失败',
          taskIdLabel: '配比运价导入任务ID:',
          downloadFile: '下载文件',
          goToRateMaintenance: '前往运价维护',
          sourceRatesLabel: '参与配比的源合约运价',
          generatedRatesLabel: '生成的运价条数',
          unmatchedRatesLabel: '未匹配运价条数',
          rowsUnit: '行',
          noUnmatchedFile: '暂无未匹配明细文件',
          stepRead: '读取合约运价',
          stepMatch: '运价匹配计算',
          stepValidate: '结果校验',
          stepDone: '配比完成',
          statMatchedDimension: '匹配维度行数',
          statMatchedContainer: '匹配箱型数',
          statUnmatchedDimension: '未匹配维度行数',
          statUnmatchedContainer: '未匹配箱型数',
          statInserted: '生成运价条数',
          failReason: '失败原因',
          cleanupHint: '清理提示',
          pollFailHint: '进度查询异常，正在重试…',
          pollStopped: '进度查询连续失败，已停止自动刷新'
        },
        nature: {
          fak: 'FAK',
          nacFix: 'Name Account (Fix)',
          ratio: '配比约价'
        }
      },
      // [CCTOWER-3605] AI解析双入口选择弹窗
      aiParseChoice: {
        title: '选择 AI 解析方式',
        textTitle: '文字运价解析',
        textDesc: '粘贴微信群、邮件、QQ中的非结构化报价消息，AI 智能提取港口、船期、各箱型价格并生成待核对草稿。',
        goText: '打开智能助手解析 →',
        contractTitle: '合约文件解析',
        contractDesc: '上传航司/船东的托书、合约等 Excel 或 PDF 文件，进行复杂的全量格式深度解析与自动化校验。',
        goContract: '前往文件解析 →',
        checkingTag: '检查中',
        checkingButton: '检查中…',
        pendingTag: '审核中',
        rejectedTag: '已驳回',
        disabledTag: '已停用',
        notActivatedTag: '未开通',
        unavailableTag: '暂不可用',
        errorTag: '状态获取失败',
        contactSales: '联系销售开通 →',
        goPending: '查看审核状态 →',
        retryCheck: '点击重试 →',
        statusPendingTitle: '合约解析开通审核中',
        statusPendingDesc: '您的开通申请正在审核中，请耐心等待审核结果。',
        statusRejectedTitle: '合约解析开通申请未通过',
        statusRejectedDesc: '请联系销售 13524664368（同微信）重新申请。',
        statusDisabledTitle: '合约解析已停用',
        statusDisabledDesc: '请联系销售 13524664368（同微信）恢复使用。',
        statusUnavailableTitle: '合约解析暂未开放',
        statusUnavailableDesc: '请联系销售 13524664368（同微信）咨询开通。'
      },
      // [CCTOWER-3605] 文字运价解析预览页
      textRatePreview: {
        breadcrumb: {
          list: 'FCL整箱运价',
          preview: '文字运价解析预览'
        },
        loading: '正在加载文字运价解析数据...',
        notFound: {
          title: '未找到运价批次数据',
          subtitle: '请检查 URL 中的 batchNo 参数是否正确',
          back: '返回对话'
        },
        summary: {
          title: '运价批次摘要',
          typeTag: 'AI 文字解析',
          statusDraft: '待确认生效',
          statusActive: '已正式生效',
          statusCancelled: '已放弃/取消',
          batchNo: '批次号 (BatchNo)',
          carrier: '船公司 (Carrier)',
          pol: '起运港 (POL)',
          missingPolTag: '缺失起运港',
          cargoType: '货物类型 (CargoType)',
          validity: '运价有效期 (Validity)',
          aiInferred: 'AI 规则推算',
          currency: '基准币种 (Currency)',
          trendNote: '运价趋势说明 (TrendNote)',
          missingPolAlertTitle: '起运港缺失提醒',
          missingPolAlertContent: 'AI 未能从原始文字中识别出起运港代码，入库后请在运价维护列表中手动补全起运港。',
          remarks: '📝 备注信息：'
        },
        cargoTypes: {
          general: '普货 (General)',
          dangerous_goods: '危险品 (DG)',
          reefer: '冷藏箱 (Reefer)',
          special: '特种箱 (Special)'
        },
        table: {
          title: '运价明细',
          count: '共 {count} 个目的港报价',
          index: '序号',
          pol: '起运港 (POL)',
          pod: '目的港 (POD)',
          podCode: '港口代码',
          gp20: '20GP',
          gp40: '40GP',
          hc20: '20HC',
          hc40: '40HC / HQ',
          hc45: '45HC / HQ',
          rf20: '20RF',
          rf40: '40RF',
          nor20: '20NOR',
          nor40: '40NOR',
          tk20: '20TK',
          tk40: '40TK',
          ot20: '20OT',
          ot40: '40OT',
          fr20: '20FR',
          fr40: '40FR',
          showAllContainers: '显示全部箱型',
          showOnlyQuoted: '仅显示有报价箱型',
          surcharge: '附加费',
          perContainer: '/箱',
          perBill: '/票',
          confidence: '置信度',
          confidenceHigh: '🟢 高',
          confidenceMedium: '🟡 中',
          confidenceLow: '🔴 低',
          note: '行备注说明'
        },
        footer: {
          statusLabel: '当前状态：',
          statusDraftDesc: '草稿待确认（尚未对客户可见）',
          statusActiveDesc: '已生效（已发布至运价系统）',
          statusCancelledDesc: '已废弃',
          backBtn: '返回对话',
          cancelBtn: '放弃导入',
          confirmBtn: '✅ 确认并正式生效',
          downloadExcelBtn: '📥 导出运价 Excel',
          viewListBtn: '前往运价维护列表查看'
        },
        messages: {
          missingBatchNo: 'URL 缺少 batchNo 参数，无法定位运价草稿',
          loadFailed: '未能查询到该批次的文字运价草稿',
          networkError: '网络或服务异常，请稍后重试',
          confirmTitle: '确认生效文字运价',
          confirmContent: '确定要将批次 {batchNo} 的 {count} 条运价正式导入系统并发布吗？',
          confirmOk: '确认导入',
          confirmCancel: '再看一眼',
          confirmSuccess: '运价导入成功已正式生效！',
          confirmSuccessDownloadHint: '运价已正式入库生效！您可以点击下方按钮导出该批次的运价 Excel 文件，或返回运价列表。',
          confirmFailed: '确认运价失败',
          cancelTitle: '放弃本次导入',
          cancelContent: '确定放弃批次 {batchNo} 的导入吗？放弃后草稿将被废弃。',
          cancelOk: '确认放弃',
          cancelCancel: '取消',
          cancelSuccess: '已废弃该运价导入草稿',
          cancelFailed: '取消失败',
          exportSuccess: '运价 Excel 导出成功',
          exportFailed: '导出运价 Excel 失败'
        }
      }
    },

    // 港前运价管理 (Preport)
    preport: {
      title: '港前运价管理',
      description: '管理港前运价信息',

      // 页面标题
      pageTitles: {
        create: '新增港前运价',
        edit: '编辑港前运价',
        detail: '港前运价详情',
        copy: '复制港前运价'
      },

      // 筛选条件
      filters: {
        priceNo: '运价编号',
        priceNoPlaceholder: '请输入运价编号',
        priceMethod: '运价类型',
        priceMethodPlaceholder: '请选择运价类型',
        transportMode: '运输方式',
        transportModePlaceholder: '请选择运输方式',
        pol: '起运港',
        polPlaceholder: '请选择起运港',
        pod: '卸货港',
        podPlaceholder: '请选择卸货港',
        status: '运价状态',
        statusPlaceholder: '请选择运价状态',
        beginDate: '生效日期',
        beginDatePlaceholder: '请选择开始日期',
        endDate: '失效日期',
        endDatePlaceholder: '请选择结束日期',
        branchLine: '支线&海铁类型',
        branchLinePlaceholder: '请选择支线&海铁类型',
        portType: '港口类型',
        portTypePlaceholder: '请选择港口类型',
        wharf: '码头',
        wharfPlaceholder: '请输入码头',
        supplier: '供应商',
        supplierPlaceholder: '请选择供应商',
        remarks: '备注',
        remarksPlaceholder: '请输入备注'
      },

      // 运价类型
      priceMethods: {
        direct: '直拖',
        branch: '支线',
        seaRail: '海铁'
      },

      // 运输方式（CCTOWER-2468）
      transportModes: {
        truck: '拖车',
        barge: '驳船',
        rail: '铁路'
      },

      // 支线类型
      branchLines: {
        haiding: '海定支线',
        zhapu: '乍浦支线'
      },

      // 海铁类型
      seaRailTypes: {
        huzhou: '湖州海铁',
        yiwu: '义乌海铁'
      },

      // 港口类型
      portTypes: {
        sea: '海港',
        air: '空港'
      },

      // 状态
      status: {
        draft: '待上架',
        published: '发布',
        invalid: '失效',
        offline: '下架',
        disabled: '禁用',
        pendingImport: '待导入'
      },

      // 货物类型
      cargoTypes: {
        general: '普货',
        dangerous: '危险品',
        refrigerated: '冷冻品',
        special: '特种箱',
        steel: '卷钢',
        liquid: '液体',
        chemical: '化工品',
        textile: '纺织品'
      },

      // 服务类型（CCTOWER-2910）
      serviceTypes: {
        FCL: '整箱',
        LCL: '拼箱',
        TRUCK: '整车'
      },

      // 表格列
      columns: {
        priceNo: '运价编号',
        priceMethod: '运价类型',
        transportMode: '运输方式',
        branchLine: '支线类型',
        pol: '起运港',
        wharf: '码头',
        regionItems: '起运区域',
        gp20: '20GP',
        gp40: '40GP',
        hc20: '20HC',
        hc40: '40HC',
        hc45: '45HC',
        nor20: '20NOR',
        nor40: '40NOR',
        tk20: '20TK',
        tk40: '40TK',
        ot20: '20OT',
        ot40: '40OT',
        fr20: '20FR',
        fr40: '40FR',
        costPrice: '成本价',
        sellPrice: '销售卖价',
        supplier: '供应商',
        validPeriod: '有效期',
        beginDate: '生效日期',
        endDate: '失效日期',
        status: '状态',
        remarks: '备注',
        createdBy: '创建人',
        modifiedBy: '修改人',
        dateCreated: '创建时间',
        dateModified: '修改时间',
        actions: '操作'
      },

      // 操作按钮
      actions: {
        search: '查询',
        reset: '重置',
        add: '新增港前运价',
        import: '导入',
        downloadTemplate: '下载导入模板',
        view: '详情',
        edit: '编辑',
        copy: '复制',
        more: '更多',
        onShelf: '上架',
        offShelf: '下架',
        delete: '删除',
        batchOperations: '批量操作',
        batchOnShelf: '批量上架',
        batchOffShelf: '批量下架',
        batchDelete: '批量删除',
        batchPriceChange: '批量改价',
        aiRecognition: 'AI识别',
        batchValidityChange: '批量改时间'
      },

      // AI识别配置
      aiRecognition: {
        title: '港前运价AI识别',
        uploadTitle: '上传港前运价文档',
        uploadDesc: '支持 PDF、Word、Excel 格式，AI 将自动识别运价信息',
        aiDescription: 'AI识别说明',
        aiFeatures: [
          'AI将自动识别运价表格中的港口、船公司、价格等信息',
          '支持多种文件格式 and 复杂表格结构',
          '识别完成后会创建后台任务进行处理',
          '请确保上传的文件清晰可读'
        ],
        successTitle: 'AI识别任务已提交',
        successDescription: '当前任务后台正在运行中，请到<strong>系统设置 - 任务管理</strong>中查看任务进度和结果。',
        goToTaskManagement: '前往任务管理',
        close: '关闭',
        uploadFile: '上传{type}文件',
        clickOrDrag: '点击或拖拽文件到此区域上传',
        supportedFormats: '支持格式：PDF、Excel、Word、图片等',
        selectFile: '选择文件',
        aiParsing: 'AI解析中...',
        aiParsingTip: 'AI正在解析文档，请稍候...'
      },

      // 导入功能
      import: {
        title: '港前运价—导入功能',
        downloadTemplate: '下载 港前运价 导入模板',
        breadcrumb: '港前运价—导入功能',
        reminderTitle: '功能提示',
        reminderLines: [
          '1. 运费将存入相应的草稿包，上架后生效。',
          '2. 如果在该周期已有对应的价格，则会覆盖原有价格。'
        ],
        dragText: '点击或将 Excel 文件拖拽至此',
        parsing: '正在解析...',
        cancel: '取消',
        submit: '提交解析',
        fallbackFilename: '港前运价导入模板.xlsx'
      },

      // 批量操作
      batch: {
        selected: '已选择 {count} 项',
        onShelfConfirm: '确定要将选中的 {count} 条运价上架吗？',
        offShelfConfirm: '确定要将选中的 {count} 条运价下架吗？',
        deleteConfirm: '确定要删除选中的 {count} 条运价吗？此操作不可恢复。',
        onShelfSuccess: '成功上架 {count} 条运价',
        offShelfSuccess: '成功下架 {count} 条运价',
        deleteSuccess: '成功删除 {count} 条运价',
        // 批量改价
        priceChange: {
          title: '批量修改运价',
          selectedRates: '已选择 {count} 条运价',
          operationReminder: '操作提醒',
          reminderContent: '此操作会修改所有选中运价的费用金额，请谨慎操作。您可以选择特定的费用类型进行批量修改。置空代表该箱型价格不变，原运价如不存在对应箱型价格，则调整不会生效。请先选择涨价还是降价，输入框里永远只输入正整数。',
          selectCharge: '选择费用',
          selectChargeDesc: '选择要批量修改价格的费用类型，如港前费、操作费等。',
          selectChargePlaceholder: '请选择要修改的费用类型',
          selectPriceMode: '选择改价模式',
          priceIncrease: '涨价',
          priceDecrease: '降价',
          setPriceMode: '固定金额',
          priceIncreaseDesc: '选择涨价模式，输入框中填写涨价金额（正整数）',
          priceDecreaseDesc: '选择降价模式，输入框中填写降价金额（正整数）',
          setPriceDesc: '选择固定金额模式，输入其中任意箱型的价格（正整数）',
          setPrice: '设置价格',
          selectChargeFirst: '请先选择费用类型，然后设置价格',
          rateListToModify: '将被修改的运价列表',
          rateDetailsList: '待修改运价列表',
          rateNo: '运价号',
          origin: '起运地',
          pol: '起运港',
          supplier: '供应商',
          status: '状态',
          showChargePrice: '（显示{charge}价格）',
          showAllCharges: '（显示所有按箱型计费费用的总计价格）',
          noData: '暂无数据',
          selectedSummary: '共选择 {count} 条运价，将批量修改{type}的价格。',
          currentChargeType: '当前选择费用类型：',
          confirmOperation: '此操作会修改选中运价的',
          confirmOperationSuffix: '金额，请确认数据准确性',
          selectChargeAndPrice: '请先选择费用类型和设置价格，然后确认修改',
          confirm: '确认',
          cancel: '取消',
          batchPriceSuccess: '批量改价成功',
          batchPriceFailed: '批量改价失败',
          batchPriceError: '批量改价出错',
          priceInputRequired: '请至少输入一个箱型的价格',
          pricePlaceholders: {
            increase: '涨价金额',
            decrease: '降价金额',
            setPrice: '固定价格',
            default: '输入价格'
          }
        },
        // 批量改时间
        timeChange: {
          title: '批量修改时间',
          operationAlert: '此操作将批量修改选中运价的时间信息，请谨慎操作',
          confirmOperation: '此操作会修改所有选中运价的时间信息，请确认数据准确性',
          etdTab: 'ETD (预计开船日)',
          etaTab: 'ETA (预计到港日)',
          validDateTab: '有效期',
          setNewEtd: '设置新的ETD (预计开船日)',
          setNewEta: '设置新的ETA (预计到港日)',
          setNewValidDate: '设置新的有效期',
          newEtd: '新ETD:',
          newEta: '新ETA:',
          validPeriod: '有效期:',
          selectEtd: '选择预计开船日',
          selectEta: '选择预计到港日',
          startDate: '开始日期',
          endDate: '结束日期',
          currentEtd: '当前ETD',
          currentEta: '当前ETA',
          currentValidPeriod: '当前有效期',
          rateListToModify: '将被修改的运价列表',
          selectedSummary: '共选择 {count} 条运价，将批量修改 {type} 信息',
          cancel: '取消',
          confirm: '确认',
          etd: 'ETD',
          eta: 'ETA',
          validDate: '有效期',
          // 新增字段
          operationReminder: '操作提醒',
          reminderContent: '此操作会修改所有选中运价的时间信息，请谨慎操作。',
          setNewEtdTitle: '设置新的ETD',
          setNewEtaTitle: '设置新的ETA',
          setNewValidDateTitle: '设置新的有效期',
          etdLabel: 'ETD',
          etaLabel: 'ETA',
          validDateLabel: '有效期',
          selectEtdPlaceholder: '请选择ETD',
          selectEtaPlaceholder: '请选择ETA',
          selectValidDateRange: '请选择生效期时间范围',
          invalidDateRange: '生效日期必须早于失效日期',
          startDatePlaceholder: '开始日期',
          endDatePlaceholder: '结束日期',
          selectedRatesList: '将被修改的运价列表',
          tipText: '此操作会修改选中运价的时间信息，请确认数据准确性',
          // 新增成功消息
          etdUpdateSuccess: '成功修改 {count} 条运价的ETD',
          etaUpdateSuccess: '成功修改 {count} 条运价的ETA',
          validDateUpdateSuccess: '成功修改 {count} 条运价的生效期',
          updateFailed: '批量修改时间失败'
        },
        // 有效期修改
        validityChange: {
          title: '批量修改有效期',
          validityPeriod: '有效期',
          selectValidityPeriod: '请选择有效期',
          startDate: '开始日期',
          endDate: '结束日期'
        },
        // 批量操作确认
        confirm: {
          online: '确认批量上架',
          offline: '确认批量下架',
          delete: '确认批量删除',
          onlineContent: '确定要上架选中的 {count} 个运价吗？',
          offlineContent: '确定要下架选中的 {count} 个运价吗？',
          deleteContent: '确定要删除选中的 {count} 个运价吗？删除后无法恢复。'
        },
        // 批量操作消息
        messages: {
          onlineSuccess: '成功上架 {count} 条运价',
          onlineFailed: '批量上架失败',
          offlineSuccess: '成功下架 {count} 条运价',
          offlineFailed: '批量下架失败',
          deleteSuccess: '成功删除 {count} 条运价',
          deleteFailed: '批量删除失败',
          validityChangeSuccess: '批量修改有效期成功',
          validityChangeFailed: '批量修改有效期失败',
          selectRatesFirst: '请先选择要{action}的运价',
          selectRatesToOnline: '请先选择要上架的运价',
          selectRatesToOffline: '请先选择要下架的运价',
          selectRatesToModify: '请先选择要修改的运价',
          selectRatesToDelete: '请先选择要删除的运价',
          onlyDraftCanOnline: '只有草稿和待导入状态的运价才能上架，当前选中包含：{status} 状态的运价',
          onlyNormalCanOffline: '只有正常状态的运价才能下架，当前选中包含：{status} 状态的运价',
          onlyDraftCanModify: '只能修改草稿状态的运价，请重新选择',
          onlyDraftCanDelete: '只有草稿状态的运价才能删除，当前选中包含：{status} 状态的运价'
        }
      },

      // 费用类型
      chargeItems: {
        preportFee: '港前费',
        handlingFee: '操作费',
        documentFee: '文件费',
        truckingFee: '拖车费'
      },

      // 批量改价
      batchPrice: {
        title: '批量改价',
        chargeItemRequired: '请选择要修改的费用类型',
        priceInputRequired: '请至少输入一个箱型的价格',
        priceUpdateFailed: '批量修改价格失败',
        setPriceSuccess: '成功设置 {count} 条运价的固定价格',
        increaseSuccess: '成功涨价 {count} 条运价',
        decreaseSuccess: '成功降价 {count} 条运价',
        pricePlaceholders: {
          increase: '涨价金额',
          decrease: '降价金额',
          setPrice: '固定价格',
          default: '输入价格'
        }
      },

      // 消息提示
      messages: {
        loadDataFailed: '加载数据失败',
        loadDataError: '加载港前运价数据失败:',
        copySuccess: '已复制运价信息到新增页面，运价编号将重新生成，请确认信息后保存',
        batchOnShelfFailed: '批量上架失败',
        batchOffShelfFailed: '批量下架失败',
        batchDeleteFailed: '批量删除失败',
        importPending: '导入功能开发中',
        templateDownloadFailed: '模板下载失败',
        onShelfSuccess: '运价已上架',
        offShelfSuccess: '运价已下架',
        statusToggleFailed: '状态切换失败',
        deleteConfirm: '确定要删除这条运价记录吗？',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        totalCount: '共 {count} 条',
        unknown: '未知',
        exportFilename: '港前运价数据',
        uploadSuccess: '文件上传成功，正在解析中',
        uploadFailed: '文件上传失败：{reason}',
        uploadUnknownStatus: '文件状态未知，请在任务中心查看',
        uploadError: '解析任务触发失败，请稍后重试',
        uploadRedirectTitle: '导入提示',
        uploadRedirectContent: '导入任务已成功触发，正在跳转到详情页查看解析进度...',
        onlyDraftCanOnline: '只有草稿和待导入状态的运价才能上架，当前选中包含：{status} 状态的运价',
        onlyNormalCanOffline: '只有正常状态的运价才能下架，当前选中包含：{status} 状态的运价',
        onlyDraftCanModify: '只能修改草稿状态的运价，当前选中包含：{status} 状态的运价，请重新选择',
        onlyDraftCanDelete: '只有草稿状态的运价才能删除，当前选中包含：{status} 状态的运价',
        statusDisabledActionError: '该运价已被禁用，无法直接上架',
        statusActionError: '{status} 状态的运价不能进行上下架操作',
        containerRate: '按箱计费',
        nonContainerRate: '非按箱计费',
        callForQuote: '电询'
      },

      // 详情页
      detail: {
        // 操作按钮
        pageActions: {
          back: '返回',
          saveDraft: '保存草稿',
          saveAndPublish: '直接上架',
          save: '保存',
          edit: '编辑',
          copy: '复制',
          copyAlert: '正在复制运价信息，运价编号将自动重新生成，请确认所有信息后保存'
        },
        // 基本信息
        basicInfo: {
          title: '基本信息',
          priceNo: '运价编号',
          priceNoPlaceholder: '系统自动生成',
          priceNoCopyPlaceholder: '复制后将自动生成新编号',
          priceMethod: '运价类型',
          priceMethodRequired: '请选择运价类型',
          branchLine: '支线类型',
          branchLinePlaceholder: '请选择支线类型',
          branchLineRequired: '请选择支线类型',
          seaRailType: '海铁类型',
          seaRailTypePlaceholder: '请选择海铁类型',
          seaRailTypeRequired: '请选择海铁类型',
          // 新增字段
          etd: '预计开船日',
          etdPlaceholder: '请选择预计开船日',
          eta: '预计到港日',
          etaPlaceholder: '请选择预计到港日',
          remarks: '备注',
          remarksPlaceholder: '请输入备注信息',
          serviceType: '服务类型',
          serviceTypePlaceholder: '请选择服务类型',
          onePrice: '一口价',
          onePricePlaceholder: '请选择是否一口价',
          receivingInstructions: '接货特殊说明',
          receivingInstructionsPlaceholder: '请输入接货特殊说明'
        },
        // 详情表单（当前页面实际文案）
        form: {
          cardTitles: {
            basicInfo: '基础信息',
            loadingInfo: '装货地信息',
            originInfo: '起运地信息',
            feeInfo: '费用明细',
            dangerousGoods: '危险品信息',
            bargeInfo: '驳船信息',
            railInfo: '铁路信息',
            doorPoint: '起运门点',
            freight: '运费',
            surchargeDetail: '附加费明细'
          },
          labels: {
            priceNo: '运价编号',
            office: '所属公司',
            supplier: '供应商',
            cargoType: '货物类型',
            validPeriod: '有效期',
            unNo: 'UN编号',
            hazardClass: '类别',
            cargoDescription: '品名',
            hsCode: 'HSCODE',
            weightLimit: '限重(KG)',
            freeBoxDays: '免箱期(天)',
            voyageDays: '航程(天)',
            containerOwnership: '箱属',
            specialPriceStatus: '特价状态',
            transportMode: '运输方式',
            bargeCarrier: '驳船船公司',
            loadingPort: '装货港',
            bargeName: '驳船船名',
            bargeVoyage: '驳船航次',
            bargeEtd: '预计开航(ETD)',
            bargeEta: '预计到港(ETA)',
            bargeVoyageDays: '驳船航程(天)',
            railCompany: '铁路公司',
            loadingStation: '装货站',
            railLineType: '线路分类',
            railTrainNo: '车次',
            railDepartureTime: '发车时间',
            addressType: '地址类型',
            pol: '起运港',
            wharf: '起运码头',
            departureStation: '起运站',
            airport: '起运机场',
            airportTerminal: '机场货站',
            country: '国家',
            province: '省/州',
            city: '市',
            district: '区/县',
            street: '乡/镇/街道',
            community: '社区',
            detailAddress: '详细地址',
            postalCode: '邮编',
            feeName: '费用名称',
            nameEn: '英文名',
            feeType: '费用类型',
            unit: '单位',
            currency: '币种',
            price: '单价',
            minCharge: '最低收费',
            maxCharge: '最高收费',
            paymentType: '付费条款',
            remark: '备注',
            action: '操作',
            countTotal: '计入总价',
            totalIncluded: '总价已包含',
            feeSource: '费用来源',
            doorPoint: '门点'
          },
          placeholders: {
            priceNoCopy: '复制后将自动生成新编号',
            priceNoAuto: '系统自动生成',
            office: '请选择所属公司',
            supplier: '请选择供应商',
            cargoType: '请选择货物类型',
            startDate: '开始日期',
            endDate: '结束日期',
            unNo: '请输入4位数字',
            hazardClass: '请选择危险品类别',
            cargoDescription: '请输入品名',
            hsCode: '请输入10位HSCODE',
            hsCodeExtra: '标准10位编码',
            weightLimit: '输入限重',
            freeBoxDays: '输入天数',
            voyageDays: '输入航程天数',
            containerOwnership: '请选择',
            specialPriceStatus: '请选择',
            bargeCarrier: '请选择驳船船公司',
            loadingPort: '请选择装货港',
            bargeName: '请输入船名',
            bargeVoyage: '请输入航次',
            date: '选择日期',
            autoCalc: '由开航/到港时间自动计算',
            railCompany: '请选择铁路公司',
            loadingStation: '请选择装货站',
            railLineType: '请输入线路分类',
            railTrainNo: '请输入车次',
            railDepartureTime: '选择发车时间',
            addressType: '请选择地址类型',
            pol: '请选择起运港',
            wharf: '请选择起运码头',
            departureStation: '请选择起运站',
            airport: '请选择起运机场',
            airportTerminal: '请输入机场货站（选填）',
            country: '请选择国家',
            province: '请选择省/州',
            city: '请选择市',
            district: '请选择区/县',
            street: '请选择乡/镇/街道',
            community: '请选择社区',
            detailAddress: '请输入详细地址',
            postalCode: '请输入邮编（选填）',
            regionPlaceholder: '请选择起运门点地址',
            unit: '单位',
            currency: '币种',
            price: '单价',
            min: '最低',
            max: '最高',
            paymentType: '请选择',
            autoEcho: '自动回显',
            feeName: '请选择',
            select: '请选择'
          },
          actions: {
            add: '添加',
            addBoxType: '添加箱型列'
          },
          options: {
            truck: '拖车',
            barge: '驳船',
            rail: '铁路',
            seaPort: '海港',
            railStation: '铁路站点',
            airport: '机场',
            prepaid: '预付',
            collect: '到付',
            notAllowSpecialPrice: '不允许申请特价',
            allowSpecialPrice: '允许申请特价',
            specialPrice: '特价',
            container: '箱',
            systemRule: '系统规则',
            manual: '手动创建',
            locked: '锁定',
            preportSurcharge: '港前附加费',
            freight: '运费'
          },
          validation: {
            office: '请选择所属公司',
            cargoType: '请选择货物类型',
            validPeriod: '请选择有效期',
            hazardClass: '危险品必填类别',
            cargoDescription: '危险品必填品名',
            containerOwnership: '请选择箱属',
            specialPriceStatus: '请选择特价状态',
            transportMode: '请选择运输方式',
            bargeCarrier: '请选择驳船船公司',
            loadingPort: '请选择装货港',
            railCompany: '请选择铁路公司',
            loadingStation: '请选择装货站',
            addressType: '请选择地址类型',
            pol: '请选择起运港',
            departureStation: '请选择起运站',
            airport: '请选择起运机场',
            hazardUnNo: '危险品必填UN编号',
            unNoFormat: 'UN编号须为4位数字',
            hazardHsCode: '危险品必填HSCODE',
            hsCodeFormat: 'HSCODE须为10位',
            partialSaveSuccess: '部分保存成功：成功 {successCount} 条，失败 {failedCount} 条',
            fee: {
              freightCurrency: '运费第{rowNo}行：请选择币种',
              freightContainerPrice: '运费第{rowNo}行：单位为箱时，请至少填写一个箱型价格',
              freightPrice: '运费第{rowNo}行：请填写单价',
              surchargeFeeName: '附加费第{rowNo}行：请选择费用名称',
              surchargeUnit: '附加费第{rowNo}行：请选择单位',
              surchargeCurrency: '附加费第{rowNo}行：请选择币种',
              surchargeContainerPrice: '附加费第{rowNo}行：单位为箱时，请至少填写一个箱型价格',
              surchargePrice: '附加费第{rowNo}行：请填写单价'
            }
          },
          hazardClasses: {
            '1': '第1类 爆炸品',
            '2': '第2类 气体',
            '3': '第3类 易燃液体',
            '4': '第4类 易燃固体',
            '5': '第5类 氧化剂',
            '6': '第6类 毒性物质',
            '7': '第7类 放射性物质',
            '8': '第8类 腐蚀品',
            '9': '第9类 杂项危险品'
          }
        },
        // 区域选择
        regionSelection: {
          title: '起运门点',
          aiRecognition: 'AI识别',
          addRegion: '添加',
          region: '门点 {index}',
          atLeastOneRegion: '至少需要保留一个区域',
          administrativeDivision: '行政区划',
          detailedLocation: '详细定位',
          detailedAddress: '详细地址',
          selectProvince: '请选择省/州',
          selectCity: '请选择市',
          selectDistrict: '请选择区/县',
          selectStreet: '请选择乡/镇/街道',
          selectCommunity: '请选择社区',
          enterDetailedAddress: '请输入详细地址',
          noRegionSet: '未设置地区',
          clickToExpand: '点击展开设置地区信息',
          selectRegionInfo: '请选择起运门点地址'
        },
        // 起运港信息
        portInfo: {
          title: '起运港信息',
          pol: '起运港',
          polRequired: '请选择起运港',
          polPlaceholder: '请选择起运港',
          wharf: '起运码头',
          wharfPlaceholder: '请选择起运码头',
          supplier: '供应商',
          supplierRequired: '请输入供应商',
          supplierPlaceholder: '请输入供应商',
          validPeriod: '有效期',
          validPeriodRequired: '请选择有效期',
          validPeriodStart: '开始日期',
          validPeriodEnd: '结束日期',
          etd: '预计开船日',
          etdPlaceholder: '请选择预计开船日',
          eta: '预计到港日',
          etaPlaceholder: '请选择预计到港日',
          remarks: '备注',
          remarksPlaceholder: '请输入备注信息'
        },
        // 箱型设置
        boxTypeSettings: {
          title: '箱型设置',
          selectBoxTypes: '选择要显示的箱型列：',
          updateSuccess: '箱型设置已更新'
        },
        // 运价明细
        rateDetails: {
          title: '运价明细',
          containerRateItems: '按箱型计费项目',
          nonContainerRateItems: '非按箱型计费项目',
          addRateItem: '添加运价项目',
          rateItem: '运价项目 {index}',
          atLeastOneRateItem: '至少需要保留一个运价项目',
          addChargingItem: '添加计费项目',
          chargingItem: '计费项目 {index}',
          atLeastOneChargingItem: '至少需要保留一个计费项目',
          specialNote: '特殊备注',
          specialNotePlaceholder: '特殊备注',
          feeName: '费用名称',
          feeNamePlaceholder: '请选择费用名称',
          basicFeePlaceholder: '请选择基础费用',
          currency: '币种',
          unit: '计费单位',
          unitPlaceholder: '请选择计费单位',
          price: '单价',
          pricePlaceholder: '请输入单价',
          priceInputPlaceholder: '请输入价格',
          autoFill: '自动填充',
          basicFee: '基础费用',
          piece: '票',
          container: '箱',
          item: '件',
          ton: '吨',
          cubicMeter: '立方米',
          teu: 'TEU',
          actions: '操作',
          containerBillingTitle: '按箱型计费项目',
          feeNameTitle: '费用名称',
          specialNoteTitle: '特殊备注'
        },
        // 保存消息
        saveMessages: {
          updateSuccess: '运价更新并上架成功！',
          createSuccess: '运价创建并上架成功！',
          saveFailed: '保存失败: ',
          unknownError: '未知错误',
          checkRequired: '请检查必填项',
          draftSaveSuccess: '草稿保存成功',
          draftSaveFailed: '保存草稿失败: ',
          onlyDraftCanSave: '只有草稿状态的运价才能保存',
          onlyDraftCanSaveDraft: '只有草稿状态的运价才能保存草稿'
        },
        // 数据加载
        dataLoading: {
          loadFailed: '加载数据失败: ',
          copyLoadFailed: '复制数据加载失败: '
        },
        // 区域翻译
        region: {
          china: '中国',
          usa: '美国',
          uk: '英国',
          germany: '德国',
          france: '法国',
          japan: '日本',
          korea: '韩国',
          singapore: '新加坡',
          australia: '澳大利亚',
          canada: '加拿大'
        },
        // [CCTOWER-2468] 干线匹配 / 离开提示 / 运输方式切换 / 附加费合计
        trunkMatch: {
          title: '匹配干线运价',
          staleAlert: '匹配条件已变更，请刷新匹配',
          refresh: '刷新匹配',
          manual: '手动匹配',
          selectTitle: '选择干线运价',
          confirm: '确定',
          cancel: '取消',
          empty: '暂未匹配干线运价',
          notFound: '未找到匹配的干线运价',
          multiCandidates: '找到 {count} 条候选干线，请手动选择',
          matchedSuccess: '已匹配到干线运价',
          selectedSuccess: '已选择干线运价',
          needPortType: '请先填写抵达节点类型',
          needPol: '请先选择起运港',
          needAirport: '请先选择机场',
          needRailStation: '请先选择起运站',
          needSelectCandidate: '请选择一条干线运价',
          typeLabel: '类型：',
          priceNoLabel: '编号：',
          officeLabel: '所属公司：',
          supplierLabel: '供应商：',
          periodLabel: '有效期：',
          combinedPriceLabel: '组合总价：',
          trunkType: '干线类型',
          priceNo: '运价编号',
          office: '所属公司',
          supplier: '供应商',
          validPeriod: '有效期',
          matchedAt: '匹配时间',
          polNode: '起运地',
          podNode: '目的地',
          spaceStatus: '舱位状态',
          priceTrend: '价格趋势',
          weekdays: '船期',
          detentionFreeDays: '免用箱',
          voyageDays: '航程',
          actions: '操作',
          detail: '详情',
          detailTitle: '干线运价详情',
          openRateDetail: '打开运价详情',
          railDetailUnavailable: '该干线类型暂不支持跳转运价详情页',
          inquiry: '电询',
          combinedBox: '港前 {pre} + 干线 {trunk} = {total}',
          gp20Total: '20GP合计',
          gp40Total: '40GP合计',
          hc40Total: '40HC合计',
          hc45Total: '45HC合计',
          nor20Total: '20NOR合计',
          nor40Total: '40NOR合计',
          typeFcl: '海运整箱',
          typeLcl: '海运拼箱',
          typeAir: '空运',
          typeRail: '铁路',
          polSeaport: '起运港',
          podSeaport: '卸货港',
          polAirport: '起运机场',
          podAirport: '目的机场',
          polRail: '起运站',
          podRail: '目的站'
        },
        leaveConfirm: {
          title: '提示',
          content: '未保存的改动将丢失，是否离开？',
          ok: '离开',
          cancel: '取消'
        },
        transportModeSwitch: {
          title: '切换运输方式',
          content: '切换后当前运输方式的条件字段将隐藏，切回时可恢复。是否继续？',
          ok: '确定',
          cancel: '取消'
        },
        portTypeSwitch: {
          title: '切换地址类型',
          content: '切换后当前地址类型的条件字段将隐藏，切回时可恢复。是否继续？',
          ok: '确定',
          cancel: '取消'
        },
        surchargeSummary: {
          rowTotal: '运费合计',
          footerLabel: '合计（计入总价）：',
          nonContainerTotal: '非箱单位合计'
        }
      }
    },

    // 尾程运价管理 (Lastmile)
    lastmile: {
      title: '尾程运价管理',
      description: '管理尾程运价信息',
      list: {
        unknown: '未知',
        messages: {
          processingBaseField: '处理基础数据字段',
          value: '值',
          getSeaportFailed: '获取港口数据失败',
          getWarehouseFailed: '获取仓库数据失败',
          findBaseData: '查找基础数据',
          queryResult: '查询结果',
          operationFailed: '操作失败'
        }
      },
      // 区域选择
      regionSelection: {
        title: '区域',
        detailedAddress: '详细地址',
        postalCodeLabel: '邮编:'
      },
      // 配送地址类型
      deliveryAddressType: {
        thirdParty: '第三方地址',
        warehouse: '仓库',
        amazonWarehouse: '亚马逊仓库',
        easyWarehouse: '易仓',
        unknown: '未知'
      },

      // 页面标题
      pageTitles: {
        create: '新增尾程运价',
        edit: '编辑尾程运价',
        detail: '尾程运价详情',
        copy: '复制尾程运价'
      },

      // 筛选字段
      filters: {
        priceMethod: '运价类型',
        status: '运价状态',
        destinationPort: '卸货港',
        agent: '代理名称',
        currency: '货币',
        feeName: '费用名称',
        unit: '单位',
        addressType: '地址类型',
        country: '国家',
        postalCode: '邮编',
        state: '州',
        city: '市',
        district: '区域',
        warehouseCode: '仓库代码'
      },

      // 占位符
      placeholders: {
        priceMethod: '请选择运价类型',
        status: '请选择运价状态',
        destinationPort: '请选择卸货港',
        agent: '请输入代理名称',
        currency: '请选择货币',
        feeName: '请选择费用名称',
        unit: '请选择单位',
        addressType: '请选择地址类型',
        country: '请选择国家',
        postalCode: '请选择邮编',
        state: '请选择州',
        city: '请选择市',
        district: '请选择区域',
        warehouseCode: '请输入仓库代码'
      },

      // 运价类型
      priceMethods: {
        direct: '直拖',
        branch: '支线',
        seaRail: '海铁'
      },

      // 运输方式（CCTOWER-2468）
      transportModes: {
        truck: '拖车',
        barge: '驳船',
        rail: '铁路'
      },

      // 服务类型（CCTOWER-2910）
      serviceTypes: {
        FCL: '整箱',
        LCL: '拼箱',
        TRUCK: '整车'
      },

      // 状态
      status: {
        draft: '待上架',
        normal: '正常',
        expired: '已失效',
        offline: '已下架',
        disabled: '已禁用',
        pendingImport: '待导入',
        unknown: '未知'
      },

      // 表格列
      columns: {
        priceNo: '尾程运价编号',
        transportMode: '运输方式',
        pods: '卸货港',
        deliveryAddressType: '地址类型',
        postalCode: '邮编',
        address: '地址',
        warehouseCode: '仓库代码',
        agentName: '代理名称',
        gp20: '20GP',
        gp40: '40GP',
        hc20: '20HC',
        hc40: '40HC',
        hc45: '45HC',
        nor20: '20NOR',
        nor40: '40NOR',
        tk20: '20TK',
        tk40: '40TK',
        ot20: '20OT',
        ot40: '40OT',
        fr20: '20FR',
        fr40: '40FR',
        costPrice: '成本价',
        sellPrice: '销售卖价',
        validPeriod: '有效期',
        status: '状态',
        createdBy: '创建人',
        dateCreated: '创建日期',
        modifiedBy: '修改人',
        modifyDate: '修改日期',
        remarks: '备注',
        actions: '操作'
      },

      // 操作按钮
      actions: {
        search: '查询',
        reset: '重置',
        import: '导入',
        add: '新增尾程运价',
        view: '详情',
        edit: '编辑',
        copy: '复制',
        more: '更多',
        onShelf: '上架',
        offShelf: '下架',
        delete: '删除',
        batchOperations: '批量操作',
        batchOnShelf: '批量上架',
        batchOffShelf: '批量下架',
        batchDelete: '批量删除',
        batchPriceChange: '批量改价',
        aiRecognition: 'AI识别',
        batchValidityChange: '批量有效期变更',
        booking: '立即订舱',
        rateTrend: '运价趋势',
        availableSailings: '可用船期',
        downloadTemplate: '下载导入模板'
      },

      // AI识别
      aiRecognition: {
        title: '尾程运价AI识别',
        uploadTitle: '上传尾程运价文档',
        uploadDesc: '支持 PDF、Word、Excel 格式，AI 将自动识别运价信息',
        priceTypeName: '尾程运价'
      },

      // 导入
      import: {
        title: '导入尾程运价',
        breadcrumb: '批量导入',
        downloadTemplate: '下载导入模板',
        reminderTitle: '功能提示',
        reminderLines: [
          '1. 导入后将生成“待导入”状态的运价，请在列表中核对无误后批量发布。',
          '2. 如果导入数据中包含重复的运价记录，系统将按冲突规则进行校验。'
        ],
        dragText: '点击或拖拽文件到此区域导入',
        parsing: '正在解析 Excel...',
        cancel: '取消',
        submit: '开始导入'
      },

      // 批量操作
      batch: {
        selected: '已选择 {count} 项',
        onShelfConfirm: '确定要将选中的 {count} 条运价上架吗？',
        offShelfConfirm: '确定要将选中的 {count} 条运价下架吗？',
        deleteConfirm: '确定要删除选中的 {count} 条运价吗？此操作不可恢复。',
        onShelfSuccess: '成功上架 {count} 条运价',
        offShelfSuccess: '成功下架 {count} 条运价',
        deleteSuccess: '成功删除 {count} 条运价',

        // 批量改价
        priceChange: {
          title: '批量修改运价',
          selectedRates: '已选择 {count} 条运价',
          operationReminder: '操作提醒',
          reminderContent: '此操作会修改所有选中运价的费用金额，请谨慎操作。您可以选择特定的费用类型进行批量修改。置空代表该箱型价格不变，原运价如不存在对应箱型价格，则调整不会生效。请先选择涨价还是降价，输入框里永远只输入正整数。',
          selectCharge: '选择费用',
          selectChargeDesc: '选择要批量修改价格的费用类型，如尾程费、送货费等。',
          selectChargePlaceholder: '请选择要修改的费用类型',
          selectPriceMode: '选择改价模式',
          priceIncrease: '涨价',
          priceDecrease: '降价',
          setPriceMode: '固定金额',
          priceIncreaseDesc: '选择涨价模式，输入框中填写涨价金额（正整数）',
          priceDecreaseDesc: '选择降价模式，输入框中填写降价金额（正整数）',
          setPriceDesc: '选择固定金额模式，输入其中任意箱型的价格（正整数）',
          setPrice: '设置价格',
          selectChargeFirst: '请先选择费用类型，然后设置价格',
          rateListToModify: '将被修改的运价列表',
          rateDetailsList: '待修改运价列表',
          rateNo: '尾程运价编号',
          destinationPort: '卸货港',
          address: '地址',
          showChargePrice: '（显示{charge}价格）',
          showAllCharges: '（显示所有按箱型计费费用的总计价格）',
          noData: '暂无数据',
          selectedSummary: '共选择 {count} 条运价，将批量修改{type}的价格。',
          currentChargeType: '当前选择费用类型：',
          confirmOperation: '此操作会修改选中运价的',
          confirmOperationSuffix: '金额，请确认数据准确性',
          selectChargeAndPrice: '请先选择费用类型和设置价格，然后确认修改',
          confirm: '确认',
          cancel: '取消',
          batchPriceSuccess: '批量改价成功',
          batchPriceFailed: '批量改价失败',
          batchPriceError: '批量改价出错',
          chargeItemRequired: '请选择费用类型',
          priceInputRequired: '请至少输入一个箱型价格的调整金额',
          pricePlaceholders: {
            increase: '涨价金额',
            decrease: '降价金额',
            setPrice: '固定价格',
            default: '输入价格'
          }
        },

        // 批量改时间
        timeChange: {
          title: '批量改时间',
          operationAlert: '此操作将批量修改选中运价的时间信息，请谨慎操作',
          etdTab: 'ETD (预计开船日)',
          etaTab: 'ETA (预计到港日)',
          validDateTab: '有效期',
          setNewEtd: '设置新的ETD (预计开船日)',
          setNewEta: '设置新的ETA (预计到港日)',
          setNewValidDate: '设置新的有效期',
          newEtd: '新ETD:',
          newEta: '新ETA:',
          validPeriod: '有效期:',
          selectEtd: '选择预计开船日',
          selectEta: '选择预计到港日',
          startDate: '开始日期',
          endDate: '结束日期',
          currentEtd: '当前ETD',
          currentEta: '当前ETA',
          currentValidPeriod: '当前有效期',
          currentValidDate: '当前有效期',
          rateListToModify: '将被修改的运价列表',
          selectedSummary: '共选择 {count} 条运价，将批量修改 {type} 信息',
          cancel: '取消',
          confirm: '确认',
          etd: 'ETD',
          eta: 'ETA',
          validDate: '有效期',

          // 新增字段
          operationReminder: '操作提醒',
          reminderContent: '此操作会修改所有选中运价的时间信息，请谨慎操作。',
          setNewEtdTitle: '设置新的ETD',
          setNewEtaTitle: '设置新的ETA',
          setNewValidDateTitle: '设置新的有效期',
          etdLabel: 'ETD',
          etaLabel: 'ETA',
          validDateLabel: '有效期',
          selectEtdPlaceholder: '请选择ETD',
          selectEtaPlaceholder: '请选择ETA',
          startDatePlaceholder: '开始日期',
          endDatePlaceholder: '结束日期',
          selectedRatesList: '将被修改的运价列表',
          tipText: '此操作会修改选中运价的时间信息，请确认数据准确性',

          // 新增成功消息
          etdUpdateSuccess: '成功修改 {count} 条运价的ETD',
          etaUpdateSuccess: '成功修改 {count} 条运价的ETA',
          validDateUpdateSuccess: '成功修改 {count} 条运价的生效期',
          updateFailed: '批量修改时间失败',
          selectValidDateRange: '请选择完整的有效期范围',
          startDateMustBeforeEndDate: '开始日期必须早于结束日期'
        },

        // 有效期修改
        validityChange: {
          title: '批量修改有效期',
          validityPeriod: '有效期',
          selectValidityPeriod: '请选择有效期',
          startDate: '开始日期',
          endDate: '结束日期'
        },

        // 批量操作确认
        confirm: {
          online: '确认批量上架',
          offline: '确认批量下架',
          delete: '确认批量删除',
          onlineContent: '确定要上架选中的 {count} 个运价吗？',
          offlineContent: '确定要下架选中的 {count} 个运价吗？',
          deleteContent: '确定要删除选中的 {count} 个运价吗？删除后无法恢复。'
        },
        messages: {
          selectRatesToOnline: '请先选择要上架的运价',
          onlineSuccess: '批量上架成功',
          onlineFailed: '批量上架失败',
          selectRatesToOffline: '请先选择要下架的运价',
          offlineSuccess: '批量下架成功',
          offlineFailed: '批量下架失败',
          selectRatesToModify: '请先选择要修改的运价',
          onlyDraftCanModify: '只能修改草稿状态的运价，请重新选择',
          validityChangeSuccess: '批量修改有效期成功',
          validityChangeFailed: '批量修改有效期失败',
          selectRatesToDelete: '请先选择要删除的运价',
          deleteSuccess: '批量删除成功',
          deleteFailed: '批量删除失败'
        }
      },

      // 费用类型
      chargeItems: {
        lastmileFee: '尾程费',
        handlingFee: '操作费',
        documentFee: '文件费',
        deliveryFee: '配送费'
      },

      // 批量改价
      batchPrice: {
        title: '批量改价',
        chargeItemRequired: '请选择要修改的费用类型',
        priceInputRequired: '请至少输入一个箱型的价格',
        priceUpdateFailed: '批量修改价格失败',
        setPriceSuccess: '成功设置 {count} 条运价的固定价格',
        increaseSuccess: '成功涨价 {count} 条运价',
        decreaseSuccess: '成功降价 {count} 条运价',
        pricePlaceholders: {
          increase: '涨价金额',
          decrease: '降价金额',
          setPrice: '固定价格',
          default: '输入价格'
        }
      },

      // 消息提示
      messages: {
        onlineSuccess: '批量上架成功',
        onlineFailed: '批量上架失败',
        offlineSuccess: '批量下架成功',
        offlineFailed: '批量下架失败',
        batchDeleteSuccess: '批量删除成功',
        batchDeleteFailed: '批量删除失败',
        validityChangeSuccess: '批量修改有效期成功',
        validityChangeFailed: '批量修改有效期失败',
        selectRatesFirst: '请先选择要{action}的运价',
        selectRatesToOnline: '请先选择要上架的运价',
        selectRatesToOffline: '请先选择要下架的运价',
        selectRatesToModify: '请先选择要修改的运价',
        selectRatesToDelete: '请先选择要删除的运价',
        onlyDraftCanOnline: '只有草稿和待导入状态的运价才能上架，当前选中包含：{status} 状态的运价',
        onlyNormalCanOffline: '只有正常状态的运价才能下架，当前选中包含：{status} 状态的运价',
        onlyDraftCanModify: '只能修改草稿状态的运价，请重新选择',
        onlyDraftCanDelete: '只有草稿状态的运价才能删除，当前选中包含：{status} 状态的运价',
        loadDataFailed: '加载数据失败',
        loadDetailFailed: '加载运价明细失败',
        loadDataError: '加载尾程运价数据失败:',
        copySuccess: '已复制运价信息到新增页面，运价编号将重新生成，请确认信息后保存',
        importPending: '导入功能开发中',
        templateDownloadFailed: '模板下载失败',
        onShelfSuccess: '运价已上架',
        offShelfSuccess: '运价已下架',
        statusToggleFailed: '状态切换失败',
        deleteConfirm: '确定要删除这条运价记录吗？',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        totalCount: '共 {count} 条',
        unknown: '未知',
        exportFilename: '尾程运载数据',
        processingBaseField: '处理基础数据字段',
        value: '值',
        getSeaportFailed: '获取港口数据失败',
        getWarehouseFailed: '获取仓库数据失败',
        findBaseData: '查找基础数据',
        queryResult: '查询结果',
        loadFailed: '数据加载失败',
        loadMoreFailed: '加载数据失败，请稍后重试',
        featureDeveloping: '{feature}功能开发中...'
      },

      // 详情页
      detail: {
        exportColumns: {
          warehouseCode: '仓库代码',
          priceNo: '尾程运价编号',
          pods: '卸货港',
          deliveryAddressType: '地址类型',
          postalCode: '邮编',
          address: '地址',
          agentName: '代理名称',
          gp20Total: '20GP',
          gp40Total: '40GP',
          hc40Total: '40HC',
          nor40Total: '40NOR',
          hc45Total: '45HC',
          beginDate: '生效日期',
          endDate: '失效日期',
          status: '状态',
          createdBy: '创建人',
          createdTime: '创建时间',
          modifiedBy: '修改人',
          updatedTime: '修改时间',
          remarks: '备注'
        },
        // 章节标题
        sections: {
          basicInfo: '基本信息',
          pickupAddress: '提货地址',
          destinationInfo: '目的地信息',
          deliveryAddress: '配送地址',
          transportConditions: '运输条件（驳船/铁路）',
          regionSelection: '地区选择',
          rateInfo: '费用明细'
        },

        // 箱型设置
        boxTypeSettings: {
          title: '箱型设置',
          selectBoxTypes: '选择要显示的箱型列：',
          updateSuccess: '箱型设置已更新'
        },

        // 操作按钮
        pageActions: {
          back: '返回',
          saveDraft: '保存草稿',
          saveAndPublish: '直接上架',
          edit: '编辑',
          copy: '复制',
          copyAlert: '正在复制运价信息，运价编号将自动重新生成，请确认所有信息后保存'
        },

        // 基本信息
        basicInfo: {
          title: '基本信息',
          priceNo: '运价编号',
          priceNoPlaceholder: '保存后自动生成',
          priceNoCopyPlaceholder: '复制后自动重新生成',
          priceMethod: '运价类型',
          priceMethodRequired: '请选择运价类型',
          priceMethodPlaceholder: '请选择运价类型',
          destinationPort: '卸货港',
          destinationPortRequired: '请选择卸货港',
          destinationPortPlaceholder: '请选择卸货港',
          agent: '代理名称',
          agentRequired: '请输入代理名称',
          agentPlaceholder: '请输入代理名称',
          validPeriod: '有效期',
          validPeriodRequired: '请选择有效期',
          validPeriodStart: '开始日期',
          validPeriodEnd: '结束日期'
        },

        // 配送地址选择
        regionSelection: {
          title: '配送地址选择',
          aiRecognition: 'AI识别',
          addRegion: '添加配送地址',
          region: '配送地址 {index}',
          atLeastOneRegion: '至少需要保留一个配送地址',
          administrativeDivision: '行政区划',
          detailedLocation: '详细定位',
          detailedAddress: '详细地址',
          detailAddress: '详细地址',
          enterDetailedAddress: '请输入详细地址（门牌号、楼栋号、房间号等）',
          noRegionSet: '未设置地区',
          clickToExpand: '点击展开设置地区信息',
          country: '国家',
          state: '省/州',
          city: '市',
          district: '区/县',
          street: '乡/镇/街道',
          community: '社区',
          deliveryAddress: '配送地址',
          addressType: '地址类型',
          thirdPartyAddress: '第三方地址',
          amazonWarehouse: '亚马逊仓库',
          easyWarehouse: '易仓',
          notSelected: '未选择',
          postalCode: '邮编',
          selectCountry: '请选择国家',
          enterPostalCode: '请输入邮编（选填）',
          selectProvince: '请选择省/州',
          selectCity: '请选择市',
          selectDistrict: '请选择区/县',
          selectStreet: '请选择乡/镇/街道',
          selectCommunity: '请选择社区',
          warehouseCode: '仓库代码',
          easyWarehouseCode: '易仓代码',
          destinationPort: '卸货港',
          selectDestinationPort: '请选择卸货港',
          multiplePortsTip: '提示: 可选择多个卸货港, 表示这些卸货港到同一配送地址的运价相同',
          agent: '代理名称',
          enterAgentName: '请输入代理名称',
          etd: '预计开船日',
          selectEtd: '请选择预计开船日',
          eta: '预计到港日',
          selectEta: '请选择预计到港日',
          validPeriod: '有效期',
          startDate: '开始日期',
          endDate: '结束日期',
          remarks: '备注',
          enterRemarks: '请输入备注',
          serviceType: '服务类型',
          selectServiceType: '请选择服务类型',
          onePrice: '一口价',
          selectOnePrice: '请选择是否一口价',
          receivingInstructions: '接货特殊说明',
          enterReceivingInstructions: '请输入接货特殊说明',
          selectAmazonWarehouse: '请选择亚马逊仓库',
          selectEasyWarehouse: '请选择易仓'
        },

        // 运价明细
        rateDetails: {
          title: '运价明细',
          containerRate: '按箱型计费',
          nonContainerRate: '非按箱型计费',
          addContainerRate: '添加按箱型计费',
          addNonContainerRate: '添加非按箱型计费',
          atLeastOneRateItem: '至少需要保留一个运价项目',
          feeName: '费用名称',
          feeNamePlaceholder: '请选择费用名称',
          currency: '币种',
          currencyPlaceholder: '请选择币种',
          unit: '计费单位',
          unitPlaceholder: '请选择计费单位',
          price: '单价',
          pricePlaceholder: '请输入',
          priceInquiry: '电询',
          specialNote: '特殊说明',
          specialNotePlaceholder: '请输入特殊备注',
          actions: '操作'
        },

        // 页面标题
        pageTitles: {
          copyRate: '复制尾程运价',
          createRate: '新增尾程运价',
          editRate: '编辑尾程运价',
          rateDetail: '尾程运价详情',
          copyLastmileRate: '复制尾程运价',
          addLastmileRate: '新增尾程运价',
          editLastmileRate: '编辑尾程运价',
          lastmileRateDetail: '尾程运价详情'
        },

        // 费用明细区域（对齐港前：基础运费 + 附加费）
        rateInfo: {
          containerRateProjects: '基础运费',
          nonContainerRateProjects: '附加费',
          noData: '暂无数据',
          selectBillingUnit: '请选择计费单位',
          enterUnitPrice: '请输入单价',
          boxTypeSettings: '箱型设置',
          addProject: '添加项目',
          selectFeeName: '请选择费用名称',
          autoFill: '自动填充',
          enterPrice: '请输入价格',
          delete: '删除',
          basicFee: '基础费用',
          specialNote: '备注',
          unitContainer: '箱',
          paymentPrepaid: '预付',
          paymentCollect: '到付',
          selectPaymentType: '请选择',
          freightFeeName: '运费',
          lastMileSurchargeType: '尾程附加费',
          feeSourceManual: '手动创建',
          feeSourceSystem: '系统规则',
          locked: '锁定',
          columns: {
            feeName: '费用名称',
            nameEn: '英文名',
            feeType: '费用类型',
            currency: '币种',
            billingUnit: '计费单位',
            unitPrice: '单价',
            specialNote: '备注',
            paymentType: '付费条款',
            feeSource: '费用来源',
            actions: '操作'
          }
        },

        // 弹窗
        modals: {
          containerSettings: '箱型设置',
          selectBoxTypes: '请选择需要显示的箱型'
        },

        // 表单字段额外项
        formFields: {
          deliveryAddressSelection: '配送地址选择',
          addAddress: '添加地址'
        },

        // 按钮
        buttons: {
          back: '返回',
          saveDraft: '保存草稿',
          directOnline: '直接上架',
          save: '保存',
          edit: '编辑',
          copy: '复制'
        },

        // 消息
        messages: {
          copyingRateInfo: '正在复制运价信息，运价编号将自动重新生成，请确认所有信息后保存',
          callForQuote: '电询',
          boxTypeSettingsUpdated: '箱型设置已更新',
          dataLoadFailed: '数据加载失败: {error}',
          unknownError: '未知错误',
          copyDataLoadFailed: '复制数据加载失败',
          copiedToNewPage: '数据已复制到新页面，请确认后保存'
        },

        // 表单验证
        validation: {
          podsRequired: '请选择至少一个卸货港',
          agentRequired: '请输入代理名称',
          validPeriodRequired: '请选择有效期',
          regionRequired: '至少需要保留一个配送地址',
          rateItemRequired: '至少需要保留一个运价项目',
          priceMethodRequired: '请选择运价类型',
          destinationPortRequired: '请选择卸货港',
          feeNameRequired: '请选择费用名称',
          currencyRequired: '请选择币种',
          unitRequired: '请选择计费单位',
          priceRequired: '请输入单价',
          atLeastOneRegionRequired: '至少需要设置一个配送地址',
          freightCurrencyRequired: '基础运费第{row}行：请选择币种',
          freightBoxPriceRequired: '基础运费第{row}行：单位为箱时，请至少填写一个箱型价格',
          freightUnitPriceRequired: '基础运费第{row}行：请填写单价',
          surchargeFeeNameRequired: '附加费第{row}行：请选择费用名称',
          surchargeUnitRequired: '附加费第{row}行：请选择单位',
          surchargeCurrencyRequired: '附加费第{row}行：请选择币种',
          surchargeBoxPriceRequired: '附加费第{row}行：单位为箱时，请至少填写一个箱型价格',
          surchargeUnitPriceRequired: '附加费第{row}行：请填写单价'
        },

        // 危险品类别
        hazardClasses: {
          class1: '第1类 爆炸品',
          class2: '第2类 气体',
          class3: '第3类 易燃液体',
          class4: '第4类 易燃固体',
          class5: '第5类 氧化剂',
          class6: '第6类 毒性物质',
          class7: '第7类 放射性物质',
          class8: '第8类 腐蚀品',
          class9: '第9类 杂项危险品'
        },

        // 保存消息
        saveMessages: {
          updateSuccess: '运价更新并上架成功！',
          createSuccess: '运价创建并上架成功！',
          saveFailed: '保存失败: ',
          unknownError: '未知错误',
          checkRequired: '请检查必填项',
          draftSaveSuccess: '草稿保存成功',
          draftSaveFailed: '保存草稿失败: ',
          onlyDraftCanSave: '只有草稿状态的运价才能保存',
          onlyDraftCanSaveDraft: '只有草稿状态的运价才能保存草稿',
          onlyDraftCanEdit: '只能修改草稿状态的运价，请重新选择'
        },

        // 数据加载
        dataLoading: {
          loadFailed: '加载数据失败: ',
          copyLoadFailed: '复制数据加载失败: ',
          loadFeeDataFailed: '加载费用数据失败',
          noBasicFeeFound: '未找到适用的基础费用，请手动选择',
          loadBasicFeeFailed: '加载基础费用失败'
        },

        // [CCTOWER-2469] 离开提示 / 运输方式切换 / 附加费合计 / 字段标签
        leaveConfirm: {
          title: '提示',
          content: '未保存的改动将丢失，是否离开？',
          ok: '离开',
          cancel: '取消'
        },
        transportModeSwitch: {
          title: '切换运输方式',
          content: '切换后当前运输方式的条件字段将隐藏，切回时可恢复。是否继续？',
          ok: '确定',
          cancel: '取消'
        },
        portTypeSwitch: {
          title: '切换地址类型',
          content: '切换后当前地址类型的条件字段将隐藏，切回时可恢复。是否继续？',
          ok: '确定',
          cancel: '取消'
        },
        addressTypeSwitch: {
          title: '切换配送地址类型',
          content: '切换后当前地址类型的条件字段将隐藏，切回时可恢复。是否继续？',
          ok: '确定',
          cancel: '取消'
        },
        surchargeSummary: {
          rowTotal: '运费合计',
          footerLabel: '合计（计入总价）：',
          nonContainerTotal: '非箱单位合计'
        },
        fields: {
          officeIds: '所属公司',
          officeIdsRequired: '请选择所属公司',
          officeIdsPlaceholder: '请选择所属公司',
          supplierId: '供应商',
          supplierIdPlaceholder: '请选择供应商',
          cargoType: '货物类型',
          cargoTypeRequired: '请选择货物类型',
          cargoTypePlaceholder: '请选择货物类型',
          cargoTypeGeneral: '普货',
          cargoTypeDangerous: '危险品',
          cargoTypeCold: '冷链',
          cargoTypeSpecial: '特货',
          hazardTitle: '危险品信息',
          unNo: 'UN编号',
          unNoRequired: '危险品必填UN编号',
          unNoPlaceholder: '请输入4位数字',
          unNoTip: '请输入4位数字',
          unNoFormat: 'UN编号须为4位数字',
          hazardClass: '类别',
          hazardClassRequired: '危险品必填类别',
          hazardClassPlaceholder: '请选择危险品类别',
          cargoDescription: '品名',
          cargoDescriptionRequired: '危险品必填品名',
          cargoDescriptionPlaceholder: '请输入品名',
          hsCode: 'HSCODE',
          hsCodeRequired: '危险品必填HSCODE',
          hsCodePlaceholder: '请输入10位HSCODE',
          hsCodeTip: '标准10位编码',
          hsCodeFormat: 'HSCODE须为10位',
          weightLimit: '限重(KG)',
          weightLimitPlaceholder: '输入限重',
          freeBoxDays: '免箱期(天)',
          freeBoxDaysPlaceholder: '输入天数',
          voyageDays: '航程(天)',
          voyageDaysPlaceholder: '输入航程天数',
          containerOwnership: '箱属',
          containerOwnershipRequired: '请选择箱属',
          containerOwnershipPlaceholder: '请选择',
          specialPriceStatus: '特价状态',
          specialPriceStatusRequired: '请选择特价状态',
          specialPriceStatusDisallow: '不允许申请特价',
          specialPriceStatusAllow: '允许申请特价',
          specialPriceStatusSpecial: '特价',
          transportMode: '运输方式',
          transportModeRequired: '请选择运输方式',
          transportModeTruck: '拖车',
          transportModeBarge: '驳船',
          transportModeRail: '铁路',
          bargeTitle: '驳船信息',
          bargeCarrierId: '船公司',
          bargeCarrierIdRequired: '请选择船公司',
          bargeCarrierIdPlaceholder: '请选择船公司',
          loadingPortId: '目的港',
          loadingPortIdRequired: '请选择目的港',
          loadingPortIdPlaceholder: '请选择目的港',
          destWharfId: '目的地码头',
          destWharfIdPlaceholder: '请选择目的地码头（选填）',
          bargeName: '驳船船名',
          bargeNamePlaceholder: '请输入船名',
          bargeVoyage: '驳船航次',
          bargeVoyagePlaceholder: '请输入航次',
          bargeEtd: '驳船开航时间',
          bargeEta: '驳船到港时间',
          bargeDatePlaceholder: '选择日期',
          bargeVoyageDays: '驳船航程(天)',
          bargeVoyageDaysPlaceholder: '输入航程天数',
          railTitle: '铁路信息',
          railCompanyId: '铁路公司',
          railCompanyIdRequired: '请选择铁路公司',
          railCompanyIdPlaceholder: '请选择铁路公司',
          loadingStationId: '目的站',
          loadingStationIdRequired: '请选择目的站',
          loadingStationIdPlaceholder: '请选择目的站',
          railLineType: '线路分类',
          railLineTypePlaceholder: '请输入线路分类',
          railTrainNo: '车次',
          railTrainNoPlaceholder: '请输入车次',
          railDepartureTime: '发车时间',
          railDepartureTimePlaceholder: '选择发车时间',
          portType: '地址类型',
          portTypeRequired: '请选择地址类型',
          portTypeSeaport: '海港',
          portTypeAirport: '机场',
          portTypeRailway: '铁路站点',
          pods: '卸货港',
          podsRequired: '请选择卸货港',
          podsPlaceholder: '请选择卸货港',
          wharfId: '卸货码头',
          wharfIdPlaceholder: '请选择卸货码头',
          departureStationId: '卸货站',
          departureStationIdRequired: '请选择卸货站',
          departureStationIdPlaceholder: '请选择卸货站',
          airportId: '卸货机场',
          airportIdRequired: '请选择卸货机场',
          airportIdPlaceholder: '请选择卸货机场',
          airportTerminal: '机场货站',
          airportTerminalPlaceholder: '请输入机场货站（选填）',
          minCharge: '最低收费',
          maxCharge: '最高收费',
          isCountTotal: '计入总价',
          isTotalIncluded: '总价已包含'
        },
        // [CCTOWER-2469] 干线匹配
        trunkMatch: {
          title: '匹配干线运价',
          staleAlert: '匹配条件已变更，请刷新匹配',
          refresh: '刷新匹配',
          manual: '手动匹配',
          selectTitle: '选择干线运价',
          confirm: '确定',
          cancel: '取消',
          empty: '暂未匹配干线运价',
          notFound: '未找到匹配的干线运价',
          multiCandidates: '找到 {count} 条候选干线，请手动选择',
          matchedSuccess: '已匹配到干线运价',
          selectedSuccess: '已选择干线运价',
          needPortType: '请先填写抵达节点类型',
          needPod: '请先选择卸货港',
          needAirport: '请先选择机场',
          needRailStation: '请先选择卸货站',
          needSelectCandidate: '请选择一条干线运价',
          typeLabel: '类型：',
          priceNoLabel: '编号：',
          officeLabel: '所属公司：',
          supplierLabel: '供应商：',
          periodLabel: '有效期：',
          combinedPriceLabel: '组合总价：',
          trunkType: '干线类型',
          priceNo: '运价编号',
          office: '所属公司',
          supplier: '供应商',
          validPeriod: '有效期',
          matchedAt: '匹配时间',
          polNode: '起运地',
          podNode: '目的地',
          spaceStatus: '舱位状态',
          priceTrend: '价格趋势',
          weekdays: '船期',
          detentionFreeDays: '免用箱',
          voyageDays: '航程',
          actions: '操作',
          detail: '详情',
          detailTitle: '干线运价详情',
          openRateDetail: '打开运价详情',
          railDetailUnavailable: '该干线类型暂不支持跳转运价详情页',
          inquiry: '电询',
          combinedBox: '尾程 {pre} + 干线 {trunk} = {total}',
          gp20Total: '20GP合计',
          gp40Total: '40GP合计',
          hc40Total: '40HC合计',
          hc45Total: '45HC合计',
          nor20Total: '20NOR合计',
          nor40Total: '40NOR合计',
          typeFcl: '海运整箱',
          typeLcl: '海运拼箱',
          typeAir: '空运',
          typeRail: '铁路',
          polSeaport: '起运港',
          podSeaport: '卸货港',
          polAirport: '起运机场',
          podAirport: '目的机场',
          polRail: '起运站',
          podRail: '目的站'
        }
      }
    }
  }
}
